import { api } from "./emptyApi.ts";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    adminB2BCreateCreate: build.mutation<
      AdminB2BCreateCreateApiResponse,
      AdminB2BCreateCreateApiArg
    >({
      query: () => ({ url: `/admin/b2b/create/`, method: "POST" }),
    }),
    adminB2BCreateDelete: build.mutation<
      AdminB2BCreateDeleteApiResponse,
      AdminB2BCreateDeleteApiArg
    >({
      query: () => ({ url: `/admin/b2b/create/`, method: "DELETE" }),
    }),
    adminB2BUpdateCreate: build.mutation<
      AdminB2BUpdateCreateApiResponse,
      AdminB2BUpdateCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/admin/b2b/update/${queryArg.id}/`,
        method: "POST",
      }),
    }),
    adminB2BUpdateDelete: build.mutation<
      AdminB2BUpdateDeleteApiResponse,
      AdminB2BUpdateDeleteApiArg
    >({
      query: (queryArg) => ({
        url: `/admin/b2b/update/${queryArg.id}/`,
        method: "DELETE",
      }),
    }),
    adminB2BDeleteCreate: build.mutation<
      AdminB2BDeleteCreateApiResponse,
      AdminB2BDeleteCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/admin/b2b/${queryArg.id}/delete/`,
        method: "POST",
      }),
    }),
    adminB2BDeleteDelete: build.mutation<
      AdminB2BDeleteDeleteApiResponse,
      AdminB2BDeleteDeleteApiArg
    >({
      query: (queryArg) => ({
        url: `/admin/b2b/${queryArg.id}/delete/`,
        method: "DELETE",
      }),
    }),
    adminBlogsList: build.query<
      AdminBlogsListApiResponse,
      AdminBlogsListApiArg
    >({
      query: () => ({ url: `/admin/blogs/` }),
    }),
    adminBlogsCreate: build.mutation<
      AdminBlogsCreateApiResponse,
      AdminBlogsCreateApiArg
    >({
      query: () => ({ url: `/admin/blogs/`, method: "POST" }),
    }),
    adminBlogsRead: build.query<
      AdminBlogsReadApiResponse,
      AdminBlogsReadApiArg
    >({
      query: (queryArg) => ({ url: `/admin/blogs/${queryArg.id}/` }),
    }),
    adminBlogsUpdate: build.mutation<
      AdminBlogsUpdateApiResponse,
      AdminBlogsUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/admin/blogs/${queryArg.id}/`,
        method: "PUT",
      }),
    }),
    adminBlogsDelete: build.mutation<
      AdminBlogsDeleteApiResponse,
      AdminBlogsDeleteApiArg
    >({
      query: (queryArg) => ({
        url: `/admin/blogs/${queryArg.id}/`,
        method: "DELETE",
      }),
    }),
    adminBundlesCreate: build.mutation<
      AdminBundlesCreateApiResponse,
      AdminBundlesCreateApiArg
    >({
      query: () => ({ url: `/admin/bundles/`, method: "POST" }),
    }),
    adminBundlesUpdate: build.mutation<
      AdminBundlesUpdateApiResponse,
      AdminBundlesUpdateApiArg
    >({
      query: () => ({ url: `/admin/bundles/`, method: "PUT" }),
    }),
    adminBundlesDelete: build.mutation<
      AdminBundlesDeleteApiResponse,
      AdminBundlesDeleteApiArg
    >({
      query: () => ({ url: `/admin/bundles/`, method: "DELETE" }),
    }),
    adminCategoriesCreateCreate: build.mutation<
      AdminCategoriesCreateCreateApiResponse,
      AdminCategoriesCreateCreateApiArg
    >({
      query: () => ({ url: `/admin/categories/create/`, method: "POST" }),
    }),
    adminCategoriesCreateUpdate: build.mutation<
      AdminCategoriesCreateUpdateApiResponse,
      AdminCategoriesCreateUpdateApiArg
    >({
      query: () => ({ url: `/admin/categories/create/`, method: "PUT" }),
    }),
    adminCategoriesCreateDelete: build.mutation<
      AdminCategoriesCreateDeleteApiResponse,
      AdminCategoriesCreateDeleteApiArg
    >({
      query: () => ({ url: `/admin/categories/create/`, method: "DELETE" }),
    }),
    adminCustomerStatusCreate: build.mutation<
      AdminCustomerStatusCreateApiResponse,
      AdminCustomerStatusCreateApiArg
    >({
      query: () => ({ url: `/admin/customer/status`, method: "POST" }),
    }),
    adminDistributorsCreateCreate: build.mutation<
      AdminDistributorsCreateCreateApiResponse,
      AdminDistributorsCreateCreateApiArg
    >({
      query: () => ({ url: `/admin/distributors/create/`, method: "POST" }),
    }),
    postAdminExclusiveProductsCreate: build.mutation<
      PostAdminExclusiveProductsCreateApiResponse,
      PostAdminExclusiveProductsCreateApiArg
    >({
      query: () => ({
        url: `/admin/exclusive-products/create/`,
        method: "POST",
      }),
    }),
    putAdminExclusiveProductsCreate: build.mutation<
      PutAdminExclusiveProductsCreateApiResponse,
      PutAdminExclusiveProductsCreateApiArg
    >({
      query: () => ({
        url: `/admin/exclusive-products/create/`,
        method: "PUT",
      }),
    }),
    deleteAdminExclusiveProductsCreate: build.mutation<
      DeleteAdminExclusiveProductsCreateApiResponse,
      DeleteAdminExclusiveProductsCreateApiArg
    >({
      query: () => ({
        url: `/admin/exclusive-products/create/`,
        method: "DELETE",
      }),
    }),
    postAdminExclusiveProductsById: build.mutation<
      PostAdminExclusiveProductsByIdApiResponse,
      PostAdminExclusiveProductsByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/admin/exclusive-products/${queryArg.id}/`,
        method: "POST",
      }),
    }),
    putAdminExclusiveProductsById: build.mutation<
      PutAdminExclusiveProductsByIdApiResponse,
      PutAdminExclusiveProductsByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/admin/exclusive-products/${queryArg.id}/`,
        method: "PUT",
      }),
    }),
    deleteAdminExclusiveProductsById: build.mutation<
      DeleteAdminExclusiveProductsByIdApiResponse,
      DeleteAdminExclusiveProductsByIdApiArg
    >({
      query: (queryArg) => ({
        url: `/admin/exclusive-products/${queryArg.id}/`,
        method: "DELETE",
      }),
    }),
    adminLoginCreate: build.mutation<
      AdminLoginCreateApiResponse,
      AdminLoginCreateApiArg
    >({
      query: () => ({ url: `/admin/login/`, method: "POST" }),
    }),
    adminLogoutCreate: build.mutation<
      AdminLogoutCreateApiResponse,
      AdminLogoutCreateApiArg
    >({
      query: () => ({ url: `/admin/logout/`, method: "POST" }),
    }),
    putAdminOrdersByIdUpdateStatus: build.mutation<
      PutAdminOrdersByIdUpdateStatusApiResponse,
      PutAdminOrdersByIdUpdateStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/admin/orders/${queryArg.id}/update-status/`,
        method: "PUT",
      }),
    }),
    adminProductsCreateCreate: build.mutation<
      AdminProductsCreateCreateApiResponse,
      AdminProductsCreateCreateApiArg
    >({
      query: () => ({ url: `/admin/products/create/`, method: "POST" }),
    }),
    adminProductsCreateUpdate: build.mutation<
      AdminProductsCreateUpdateApiResponse,
      AdminProductsCreateUpdateApiArg
    >({
      query: () => ({ url: `/admin/products/create/`, method: "PUT" }),
    }),
    adminProductsCreateDelete: build.mutation<
      AdminProductsCreateDeleteApiResponse,
      AdminProductsCreateDeleteApiArg
    >({
      query: () => ({ url: `/admin/products/create/`, method: "DELETE" }),
    }),
    adminProductsCreate: build.mutation<
      AdminProductsCreateApiResponse,
      AdminProductsCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/admin/products/${queryArg.id}/`,
        method: "POST",
      }),
    }),
    adminProductsUpdate: build.mutation<
      AdminProductsUpdateApiResponse,
      AdminProductsUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/admin/products/${queryArg.id}/`,
        method: "PUT",
      }),
    }),
    adminProductsDelete: build.mutation<
      AdminProductsDeleteApiResponse,
      AdminProductsDeleteApiArg
    >({
      query: (queryArg) => ({
        url: `/admin/products/${queryArg.id}/`,
        method: "DELETE",
      }),
    }),
    postAestheticInformation: build.mutation<
      PostAestheticInformationApiResponse,
      PostAestheticInformationApiArg
    >({
      query: (queryArg) => ({
        url: `/aesthetic-information/`,
        method: "POST",
        body: queryArg.aestheticLookup,
      }),
    }),
    postAestheticProducts: build.mutation<
      PostAestheticProductsApiResponse,
      PostAestheticProductsApiArg
    >({
      query: (queryArg) => ({
        url: `/aesthetic-products/`,
        method: "POST",
        body: queryArg.aestheticLookup,
      }),
    }),
    aestheticsList: build.query<
      AestheticsListApiResponse,
      AestheticsListApiArg
    >({
      query: () => ({ url: `/aesthetics/` }),
    }),
    postAnalyzeFace: build.mutation<
      PostAnalyzeFaceApiResponse,
      PostAnalyzeFaceApiArg
    >({
      query: (queryArg) => ({
        url: `/analyze-face/`,
        method: "POST",
        body: queryArg.faceAnalysis,
      }),
    }),
    postApiProductProxyScore: build.mutation<
      PostApiProductProxyScoreApiResponse,
      PostApiProductProxyScoreApiArg
    >({
      query: (queryArg) => ({
        url: `/api/product-proxy-score/`,
        method: "POST",
        body: queryArg.generateScoreInput,
      }),
    }),
    authGoogleCallbackList: build.query<
      AuthGoogleCallbackListApiResponse,
      AuthGoogleCallbackListApiArg
    >({
      query: () => ({ url: `/auth/google/callback/` }),
    }),
    postB2BContactLeads: build.mutation<
      PostB2BContactLeadsApiResponse,
      PostB2BContactLeadsApiArg
    >({
      query: (queryArg) => ({
        url: `/b2b-contact-leads/`,
        method: "POST",
        body: queryArg.b2BContactLeadCreate,
      }),
    }),
    postB2BProductScore: build.mutation<
      PostB2BProductScoreApiResponse,
      PostB2BProductScoreApiArg
    >({
      query: (queryArg) => ({
        url: `/b2b-product-score/`,
        method: "POST",
        body: queryArg.productScoreRequest,
      }),
    }),
    postB2BProfileReport: build.mutation<
      PostB2BProfileReportApiResponse,
      PostB2BProfileReportApiArg
    >({
      query: (queryArg) => ({
        url: `/b2b-profile-report/`,
        method: "POST",
        body: queryArg.completeProfile,
      }),
    }),
    postB2BBuyApiRequests: build.mutation<
      PostB2BBuyApiRequestsApiResponse,
      PostB2BBuyApiRequestsApiArg
    >({
      query: () => ({ url: `/b2b/buy-api-requests/`, method: "POST" }),
    }),
    postB2BCompleteBuyRequest: build.mutation<
      PostB2BCompleteBuyRequestApiResponse,
      PostB2BCompleteBuyRequestApiArg
    >({
      query: () => ({ url: `/b2b/complete-buy-request/`, method: "POST" }),
    }),
    postB2BGenerateApiKey: build.mutation<
      PostB2BGenerateApiKeyApiResponse,
      PostB2BGenerateApiKeyApiArg
    >({
      query: () => ({ url: `/b2b/generate-api-key/`, method: "POST" }),
    }),
    getB2BLoginWithToken: build.query<
      GetB2BLoginWithTokenApiResponse,
      GetB2BLoginWithTokenApiArg
    >({
      query: () => ({ url: `/b2b/login-with-token/` }),
    }),
    b2BLoginCreate: build.mutation<
      B2BLoginCreateApiResponse,
      B2BLoginCreateApiArg
    >({
      query: () => ({ url: `/b2b/login/`, method: "POST" }),
    }),
    postB2BUpdatePassword: build.mutation<
      PostB2BUpdatePasswordApiResponse,
      PostB2BUpdatePasswordApiArg
    >({
      query: () => ({ url: `/b2b/update-password/`, method: "POST" }),
    }),
    getBodyTypes: build.query<GetBodyTypesApiResponse, GetBodyTypesApiArg>({
      query: () => ({ url: `/body-types/` }),
    }),
    postBrandInformation: build.mutation<
      PostBrandInformationApiResponse,
      PostBrandInformationApiArg
    >({
      query: (queryArg) => ({
        url: `/brand-information/`,
        method: "POST",
        body: queryArg.brandLookup,
      }),
    }),
    postBrandProducts: build.mutation<
      PostBrandProductsApiResponse,
      PostBrandProductsApiArg
    >({
      query: (queryArg) => ({
        url: `/brand-products/`,
        method: "POST",
        body: queryArg.brandLookup,
      }),
    }),
    brandsList: build.query<BrandsListApiResponse, BrandsListApiArg>({
      query: () => ({ url: `/brands/` }),
    }),
    bundlesList: build.query<BundlesListApiResponse, BundlesListApiArg>({
      query: () => ({ url: `/bundles/` }),
    }),
    postCartCheckout: build.mutation<
      PostCartCheckoutApiResponse,
      PostCartCheckoutApiArg
    >({
      query: (queryArg) => ({
        url: `/cart-checkout/`,
        method: "POST",
        body: queryArg.cart,
      }),
    }),
    postCheckCategory: build.mutation<
      PostCheckCategoryApiResponse,
      PostCheckCategoryApiArg
    >({
      query: (queryArg) => ({
        url: `/check-category/`,
        method: "POST",
        body: queryArg.checkCategoryRequest,
      }),
    }),
    postCheckSurveyStatus: build.mutation<
      PostCheckSurveyStatusApiResponse,
      PostCheckSurveyStatusApiArg
    >({
      query: () => ({ url: `/check-survey-status/`, method: "POST" }),
    }),
    postClaimSurvey: build.mutation<
      PostClaimSurveyApiResponse,
      PostClaimSurveyApiArg
    >({
      query: (queryArg) => ({
        url: `/claim-survey/`,
        method: "POST",
        body: queryArg.claimSurvey,
      }),
    }),
    postCollectionTopMatches: build.mutation<
      PostCollectionTopMatchesApiResponse,
      PostCollectionTopMatchesApiArg
    >({
      query: (queryArg) => ({
        url: `/collection-top-matches/`,
        method: "POST",
        body: queryArg.topMatchesExclude,
      }),
    }),
    postContactUs: build.mutation<
      PostContactUsApiResponse,
      PostContactUsApiArg
    >({
      query: (queryArg) => ({
        url: `/contact-us/`,
        method: "POST",
        body: queryArg.contactUsLeadCreate,
      }),
    }),
    conversationsDelete: build.mutation<
      ConversationsDeleteApiResponse,
      ConversationsDeleteApiArg
    >({
      query: () => ({ url: `/conversations/`, method: "DELETE" }),
    }),
    conversationsListList: build.query<
      ConversationsListListApiResponse,
      ConversationsListListApiArg
    >({
      query: () => ({ url: `/conversations/list/` }),
    }),
    conversationsMessagesCreate: build.mutation<
      ConversationsMessagesCreateApiResponse,
      ConversationsMessagesCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/conversations/messages/`,
        method: "POST",
        body: queryArg.getMessages,
      }),
    }),
    conversationsStoreMessagesCreate: build.mutation<
      ConversationsStoreMessagesCreateApiResponse,
      ConversationsStoreMessagesCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/conversations/store/messages/`,
        method: "POST",
        body: queryArg.getMessages,
      }),
    }),
    postCreateBoard: build.mutation<
      PostCreateBoardApiResponse,
      PostCreateBoardApiArg
    >({
      query: (queryArg) => ({
        url: `/create-board/`,
        method: "POST",
        body: queryArg.boardCreate,
      }),
    }),
    postCreateConversation: build.mutation<
      PostCreateConversationApiResponse,
      PostCreateConversationApiArg
    >({
      query: (queryArg) => ({
        url: `/create-conversation/`,
        method: "POST",
        body: queryArg.createConversation,
      }),
    }),
    postCreateThread: build.mutation<
      PostCreateThreadApiResponse,
      PostCreateThreadApiArg
    >({
      query: (queryArg) => ({
        url: `/create-thread/`,
        method: "POST",
        body: queryArg.thread,
      }),
    }),
    deleteDeactivateAccount: build.mutation<
      DeleteDeactivateAccountApiResponse,
      DeleteDeactivateAccountApiArg
    >({
      query: () => ({ url: `/deactivate-account/`, method: "DELETE" }),
    }),
    deleteDeleteBoard: build.mutation<
      DeleteDeleteBoardApiResponse,
      DeleteDeleteBoardApiArg
    >({
      query: () => ({ url: `/delete-board/`, method: "DELETE" }),
    }),
    deleteDeleteConversation: build.mutation<
      DeleteDeleteConversationApiResponse,
      DeleteDeleteConversationApiArg
    >({
      query: () => ({ url: `/delete-conversation/`, method: "DELETE" }),
    }),
    deleteDeletePin: build.mutation<
      DeleteDeletePinApiResponse,
      DeleteDeletePinApiArg
    >({
      query: () => ({ url: `/delete-pin/`, method: "DELETE" }),
    }),
    deleteDeleteStore: build.mutation<
      DeleteDeleteStoreApiResponse,
      DeleteDeleteStoreApiArg
    >({
      query: () => ({ url: `/delete-store/`, method: "DELETE" }),
    }),
    postEditBoard: build.mutation<
      PostEditBoardApiResponse,
      PostEditBoardApiArg
    >({
      query: (queryArg) => ({
        url: `/edit-board/`,
        method: "POST",
        body: queryArg.boardRename,
      }),
    }),
    getExclusiveProductsAll: build.query<
      GetExclusiveProductsAllApiResponse,
      GetExclusiveProductsAllApiArg
    >({
      query: (queryArg) => ({
        url: `/exclusive-products-all/`,
        params: {
          page: queryArg.page,
          page_size: queryArg.pageSize,
        },
      }),
    }),
    postExclusiveTopMatches: build.mutation<
      PostExclusiveTopMatchesApiResponse,
      PostExclusiveTopMatchesApiArg
    >({
      query: (queryArg) => ({
        url: `/exclusive-top-matches/`,
        method: "POST",
        body: queryArg.exclusiveRelated,
      }),
    }),
    getFaceShapes: build.query<GetFaceShapesApiResponse, GetFaceShapesApiArg>({
      query: () => ({ url: `/face-shapes/` }),
    }),
    getFashionChatbot: build.query<
      GetFashionChatbotApiResponse,
      GetFashionChatbotApiArg
    >({
      query: () => ({ url: `/fashion-chatbot/` }),
    }),
    postFashionChatbot: build.mutation<
      PostFashionChatbotApiResponse,
      PostFashionChatbotApiArg
    >({
      query: (queryArg) => ({
        url: `/fashion-chatbot/`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getGetBoards: build.query<GetGetBoardsApiResponse, GetGetBoardsApiArg>({
      query: () => ({ url: `/get-boards/` }),
    }),
    postGetPins: build.mutation<PostGetPinsApiResponse, PostGetPinsApiArg>({
      query: (queryArg) => ({
        url: `/get-pins/`,
        method: "POST",
        body: queryArg.pinList,
      }),
    }),
    getGetUserThreads: build.query<
      GetGetUserThreadsApiResponse,
      GetGetUserThreadsApiArg
    >({
      query: () => ({ url: `/get-user-threads/` }),
    }),
    getGoogleLogin: build.query<
      GetGoogleLoginApiResponse,
      GetGoogleLoginApiArg
    >({
      query: () => ({ url: `/google-login/` }),
    }),
    getImagesOutfits: build.query<
      GetImagesOutfitsApiResponse,
      GetImagesOutfitsApiArg
    >({
      query: () => ({ url: `/images-outfits/` }),
    }),
    inventoryList: build.query<InventoryListApiResponse, InventoryListApiArg>({
      query: () => ({ url: `/inventory/` }),
    }),
    loginCreate: build.mutation<LoginCreateApiResponse, LoginCreateApiArg>({
      query: (queryArg) => ({
        url: `/login/`,
        method: "POST",
        body: queryArg.login,
      }),
    }),
    logoutCreate: build.mutation<LogoutCreateApiResponse, LogoutCreateApiArg>({
      query: () => ({ url: `/logout/`, method: "POST" }),
    }),
    getMarketplaceProductsAll: build.query<
      GetMarketplaceProductsAllApiResponse,
      GetMarketplaceProductsAllApiArg
    >({
      query: (queryArg) => ({
        url: `/marketplace-products/all/`,
        params: {
          page: queryArg.page,
          page_size: queryArg.pageSize,
        },
      }),
    }),
    getMarketplaceProductsTop: build.query<
      GetMarketplaceProductsTopApiResponse,
      GetMarketplaceProductsTopApiArg
    >({
      query: () => ({ url: `/marketplace-products/top/` }),
    }),
    postMarketplaceSurveySuggestions: build.mutation<
      PostMarketplaceSurveySuggestionsApiResponse,
      PostMarketplaceSurveySuggestionsApiArg
    >({
      query: (queryArg) => ({
        url: `/marketplace-survey-suggestions/`,
        method: "POST",
        body: queryArg.marketplaceSurveySuggestionRequest,
      }),
    }),
    postMenFashionChatbotMobile: build.mutation<
      PostMenFashionChatbotMobileApiResponse,
      PostMenFashionChatbotMobileApiArg
    >({
      query: (queryArg) => ({
        url: `/men-fashion-chatbot-mobile/`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postMenFashionChatbot: build.mutation<
      PostMenFashionChatbotApiResponse,
      PostMenFashionChatbotApiArg
    >({
      query: (queryArg) => ({
        url: `/men-fashion-chatbot/`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postMenStreamedFashionChatbotMobile: build.mutation<
      PostMenStreamedFashionChatbotMobileApiResponse,
      PostMenStreamedFashionChatbotMobileApiArg
    >({
      query: (queryArg) => ({
        url: `/men-streamed-fashion-chatbot-mobile/`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postMenStreamedFashionChatbot: build.mutation<
      PostMenStreamedFashionChatbotApiResponse,
      PostMenStreamedFashionChatbotApiArg
    >({
      query: (queryArg) => ({
        url: `/men-streamed-fashion-chatbot/`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postMoreProductsSearch: build.mutation<
      PostMoreProductsSearchApiResponse,
      PostMoreProductsSearchApiArg
    >({
      query: (queryArg) => ({
        url: `/more-products-search/`,
        method: "POST",
        body: queryArg.moreProductsSearch,
      }),
    }),
    postMultiGarmentTryOn: build.mutation<
      PostMultiGarmentTryOnApiResponse,
      PostMultiGarmentTryOnApiArg
    >({
      query: (queryArg) => ({
        url: `/multi-garment-try-on/`,
        method: "POST",
        body: queryArg.multiGarmentTryOn,
      }),
    }),
    getMyBodyType: build.query<GetMyBodyTypeApiResponse, GetMyBodyTypeApiArg>({
      query: () => ({ url: `/my-body-type/` }),
    }),
    getMyColorAnalysis: build.query<
      GetMyColorAnalysisApiResponse,
      GetMyColorAnalysisApiArg
    >({
      query: () => ({ url: `/my-color-analysis/` }),
    }),
    getMyFaceShape: build.query<
      GetMyFaceShapeApiResponse,
      GetMyFaceShapeApiArg
    >({
      query: () => ({ url: `/my-face-shape/` }),
    }),
    postNewFashionChatbotMobile: build.mutation<
      PostNewFashionChatbotMobileApiResponse,
      PostNewFashionChatbotMobileApiArg
    >({
      query: (queryArg) => ({
        url: `/new-fashion-chatbot-mobile/`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postNewFashionChatbot: build.mutation<
      PostNewFashionChatbotApiResponse,
      PostNewFashionChatbotApiArg
    >({
      query: (queryArg) => ({
        url: `/new-fashion-chatbot/`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postNewMarketplaceChatbotStreamed: build.mutation<
      PostNewMarketplaceChatbotStreamedApiResponse,
      PostNewMarketplaceChatbotStreamedApiArg
    >({
      query: (queryArg) => ({
        url: `/new-marketplace-chatbot-streamed/`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postNewStreamedFashionChatbotMarketplaceMobile: build.mutation<
      PostNewStreamedFashionChatbotMarketplaceMobileApiResponse,
      PostNewStreamedFashionChatbotMarketplaceMobileApiArg
    >({
      query: (queryArg) => ({
        url: `/new-streamed-fashion-chatbot-marketplace-mobile/`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postNewStreamedFashionChatbotMarketplace: build.mutation<
      PostNewStreamedFashionChatbotMarketplaceApiResponse,
      PostNewStreamedFashionChatbotMarketplaceApiArg
    >({
      query: (queryArg) => ({
        url: `/new-streamed-fashion-chatbot-marketplace/`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postNewStreamedFashionChatbotMobile: build.mutation<
      PostNewStreamedFashionChatbotMobileApiResponse,
      PostNewStreamedFashionChatbotMobileApiArg
    >({
      query: (queryArg) => ({
        url: `/new-streamed-fashion-chatbot-mobile/`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postNewStreamedFashionChatbotThread: build.mutation<
      PostNewStreamedFashionChatbotThreadApiResponse,
      PostNewStreamedFashionChatbotThreadApiArg
    >({
      query: (queryArg) => ({
        url: `/new-streamed-fashion-chatbot-thread/`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postNewStreamedFashionChatbot: build.mutation<
      PostNewStreamedFashionChatbotApiResponse,
      PostNewStreamedFashionChatbotApiArg
    >({
      query: (queryArg) => ({
        url: `/new-streamed-fashion-chatbot/`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postNewWebSearch: build.mutation<
      PostNewWebSearchApiResponse,
      PostNewWebSearchApiArg
    >({
      query: (queryArg) => ({
        url: `/new-web-search/`,
        method: "POST",
        body: queryArg.body,
        params: {
          gender: queryArg.gender,
          region: queryArg.region,
          garment_type: queryArg.garmentType,
          occasion_type: queryArg.occasionType,
          categories_type: queryArg.categoriesType,
          fit_type: queryArg.fitType,
          size_type: queryArg.sizeType,
          color: queryArg.color,
          aesthetic: queryArg.aesthetic,
          sustainability: queryArg.sustainability,
          min_price: queryArg.minPrice,
          max_price: queryArg.maxPrice,
        },
      }),
    }),
    ordersList: build.query<OrdersListApiResponse, OrdersListApiArg>({
      query: () => ({ url: `/orders/` }),
    }),
    ordersStatusRead: build.query<
      OrdersStatusReadApiResponse,
      OrdersStatusReadApiArg
    >({
      query: (queryArg) => ({ url: `/orders/status/${queryArg.orderId}/` }),
    }),
    ordersSuccessRead: build.query<
      OrdersSuccessReadApiResponse,
      OrdersSuccessReadApiArg
    >({
      query: (queryArg) => ({ url: `/orders/success/${queryArg.sessionId}/` }),
    }),
    postPasswordResetConfirmByUidb64AndToken: build.mutation<
      PostPasswordResetConfirmByUidb64AndTokenApiResponse,
      PostPasswordResetConfirmByUidb64AndTokenApiArg
    >({
      query: (queryArg) => ({
        url: `/password-reset-confirm/${queryArg.uidb64}/${queryArg.token}/`,
        method: "POST",
        body: queryArg.passwordResetConfirm,
      }),
    }),
    postPasswordReset: build.mutation<
      PostPasswordResetApiResponse,
      PostPasswordResetApiArg
    >({
      query: (queryArg) => ({
        url: `/password-reset/`,
        method: "POST",
        body: queryArg.passwordResetRequest,
      }),
    }),
    paymentsConfigList: build.query<
      PaymentsConfigListApiResponse,
      PaymentsConfigListApiArg
    >({
      query: () => ({ url: `/payments/config/` }),
    }),
    getPersonalitySurvey: build.query<
      GetPersonalitySurveyApiResponse,
      GetPersonalitySurveyApiArg
    >({
      query: () => ({ url: `/personality-survey/` }),
    }),
    postPersonalitySurvey: build.mutation<
      PostPersonalitySurveyApiResponse,
      PostPersonalitySurveyApiArg
    >({
      query: (queryArg) => ({
        url: `/personality-survey/`,
        method: "POST",
        body: queryArg.personality,
      }),
    }),
    getProductSuggestions: build.query<
      GetProductSuggestionsApiResponse,
      GetProductSuggestionsApiArg
    >({
      query: () => ({ url: `/product-suggestions/` }),
    }),
    getProductsAllProducts: build.query<
      GetProductsAllProductsApiResponse,
      GetProductsAllProductsApiArg
    >({
      query: (queryArg) => ({
        url: `/products/all-products/`,
        params: {
          page: queryArg.page,
          page_size: queryArg.pageSize,
        },
      }),
    }),
    getProductsTopMatches: build.query<
      GetProductsTopMatchesApiResponse,
      GetProductsTopMatchesApiArg
    >({
      query: () => ({ url: `/products/top-matches/` }),
    }),
    productsRead: build.query<ProductsReadApiResponse, ProductsReadApiArg>({
      query: (queryArg) => ({ url: `/products/${queryArg.slug}/` }),
    }),
    profileRead: build.query<ProfileReadApiResponse, ProfileReadApiArg>({
      query: () => ({ url: `/profile/` }),
    }),
    profileImagesList: build.query<
      ProfileImagesListApiResponse,
      ProfileImagesListApiArg
    >({
      query: () => ({ url: `/profile/images/` }),
    }),
    profileMeasurementsUpdate: build.mutation<
      ProfileMeasurementsUpdateApiResponse,
      ProfileMeasurementsUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/profile/measurements/`,
        method: "PUT",
        body: queryArg.profileMeasurement,
      }),
    }),
    profileMeasurementsStoreUpdate: build.mutation<
      ProfileMeasurementsStoreUpdateApiResponse,
      ProfileMeasurementsStoreUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/profile/measurements/store/`,
        method: "PUT",
        body: queryArg.profileMeasurement,
      }),
    }),
    profileMeasurementsUpdateUpdate: build.mutation<
      ProfileMeasurementsUpdateUpdateApiResponse,
      ProfileMeasurementsUpdateUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/profile/measurements/update/`,
        method: "PUT",
        body: queryArg.profileMeasurementUpdate,
      }),
    }),
    profileUpdateUpdate: build.mutation<
      ProfileUpdateUpdateApiResponse,
      ProfileUpdateUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/profile/update/`,
        method: "PUT",
        body: queryArg.profileUpdate,
      }),
    }),
    postPublicCollectionTopMatches: build.mutation<
      PostPublicCollectionTopMatchesApiResponse,
      PostPublicCollectionTopMatchesApiArg
    >({
      query: (queryArg) => ({
        url: `/public-collection-top-matches/`,
        method: "POST",
        body: queryArg.topMatchesExclude,
      }),
    }),
    postPublicMarketplaceSearch: build.mutation<
      PostPublicMarketplaceSearchApiResponse,
      PostPublicMarketplaceSearchApiArg
    >({
      query: (queryArg) => ({
        url: `/public-marketplace-search/`,
        method: "POST",
        body: queryArg.body,
        params: {
          gender: queryArg.gender,
          region: queryArg.region,
          garment_type: queryArg.garmentType,
          occasion_type: queryArg.occasionType,
          categories_type: queryArg.categoriesType,
          fit_type: queryArg.fitType,
          size_type: queryArg.sizeType,
          color: queryArg.color,
          aesthetic: queryArg.aesthetic,
          sustainability: queryArg.sustainability,
          min_price: queryArg.minPrice,
          max_price: queryArg.maxPrice,
        },
      }),
    }),
    getPublicMarketplaceSuggestions: build.query<
      GetPublicMarketplaceSuggestionsApiResponse,
      GetPublicMarketplaceSuggestionsApiArg
    >({
      query: () => ({ url: `/public-marketplace-suggestions/` }),
    }),
    postPublicNewStreamedFashionChatbotThread: build.mutation<
      PostPublicNewStreamedFashionChatbotThreadApiResponse,
      PostPublicNewStreamedFashionChatbotThreadApiArg
    >({
      query: (queryArg) => ({
        url: `/public-new-streamed-fashion-chatbot-thread/`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postPublicSingleMarketplaceProductStream: build.mutation<
      PostPublicSingleMarketplaceProductStreamApiResponse,
      PostPublicSingleMarketplaceProductStreamApiArg
    >({
      query: (queryArg) => ({
        url: `/public-single-marketplace-product-stream/`,
        method: "POST",
        body: queryArg.publicSingleProductMatch,
      }),
    }),
    postPublicTopProducts: build.mutation<
      PostPublicTopProductsApiResponse,
      PostPublicTopProductsApiArg
    >({
      query: (queryArg) => ({
        url: `/public-top-products/`,
        method: "POST",
        body: queryArg.singleProductMatch,
      }),
    }),
    postPublicAnalyzeFace: build.mutation<
      PostPublicAnalyzeFaceApiResponse,
      PostPublicAnalyzeFaceApiArg
    >({
      query: (queryArg) => ({
        url: `/public/analyze-face/`,
        method: "POST",
        body: queryArg.publicFaceAnalysis,
      }),
    }),
    publicBlogsList: build.query<
      PublicBlogsListApiResponse,
      PublicBlogsListApiArg
    >({
      query: (queryArg) => ({
        url: `/public/blogs/`,
        params: {
          page: queryArg.page,
          page_size: queryArg.pageSize,
        },
      }),
    }),
    publicBlogsRead: build.query<
      PublicBlogsReadApiResponse,
      PublicBlogsReadApiArg
    >({
      query: (queryArg) => ({ url: `/public/blogs/${queryArg.slug}/` }),
    }),
    postPublicFashionChatbot: build.mutation<
      PostPublicFashionChatbotApiResponse,
      PostPublicFashionChatbotApiArg
    >({
      query: (queryArg) => ({
        url: `/public/fashion-chatbot/`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    publicProductsAllList: build.query<
      PublicProductsAllListApiResponse,
      PublicProductsAllListApiArg
    >({
      query: (queryArg) => ({
        url: `/public/products/all/`,
        params: {
          page: queryArg.page,
          page_size: queryArg.pageSize,
        },
      }),
    }),
    publicProductsRead: build.query<
      PublicProductsReadApiResponse,
      PublicProductsReadApiArg
    >({
      query: (queryArg) => ({ url: `/public/products/${queryArg.slug}/` }),
    }),
    publicProfileMeasurementsStoreUpdate: build.mutation<
      PublicProfileMeasurementsStoreUpdateApiResponse,
      PublicProfileMeasurementsStoreUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/public/profile/measurements/store/`,
        method: "PUT",
        body: queryArg.guestSurveyMeasurement,
      }),
    }),
    postPublicUploadImage: build.mutation<
      PostPublicUploadImageApiResponse,
      PostPublicUploadImageApiArg
    >({
      query: (queryArg) => ({
        url: `/public/upload-image/`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postQuickPayCreateIntent: build.mutation<
      PostQuickPayCreateIntentApiResponse,
      PostQuickPayCreateIntentApiArg
    >({
      query: (queryArg) => ({
        url: `/quick-pay/create-intent/`,
        method: "POST",
        body: queryArg.quickPayCart,
      }),
    }),
    getQuickPayStatusByOrderId: build.query<
      GetQuickPayStatusByOrderIdApiResponse,
      GetQuickPayStatusByOrderIdApiArg
    >({
      query: (queryArg) => ({ url: `/quick-pay/status/${queryArg.orderId}/` }),
    }),
    postResendOtp: build.mutation<
      PostResendOtpApiResponse,
      PostResendOtpApiArg
    >({
      query: (queryArg) => ({
        url: `/resend-otp/`,
        method: "POST",
        body: queryArg.resendOtp,
      }),
    }),
    postSaveBoard: build.mutation<
      PostSaveBoardApiResponse,
      PostSaveBoardApiArg
    >({
      query: (queryArg) => ({
        url: `/save-board/`,
        method: "POST",
        body: queryArg.board,
      }),
    }),
    postSavePin: build.mutation<PostSavePinApiResponse, PostSavePinApiArg>({
      query: (queryArg) => ({
        url: `/save-pin/`,
        method: "POST",
        body: queryArg.pinSave,
      }),
    }),
    getSeasonalColors: build.query<
      GetSeasonalColorsApiResponse,
      GetSeasonalColorsApiArg
    >({
      query: () => ({ url: `/seasonal-colors/` }),
    }),
    postShopifyBypass2Fa: build.mutation<
      PostShopifyBypass2FaApiResponse,
      PostShopifyBypass2FaApiArg
    >({
      query: (queryArg) => ({
        url: `/shopify-bypass-2fa/`,
        method: "POST",
        body: queryArg.shopifySignedEmail,
      }),
    }),
    postShopifyEmailLogin: build.mutation<
      PostShopifyEmailLoginApiResponse,
      PostShopifyEmailLoginApiArg
    >({
      query: (queryArg) => ({
        url: `/shopify-email-login/`,
        method: "POST",
        body: queryArg.shopifySignedEmail,
      }),
    }),
    postShopifyProductFashionChatbot: build.mutation<
      PostShopifyProductFashionChatbotApiResponse,
      PostShopifyProductFashionChatbotApiArg
    >({
      query: (queryArg) => ({
        url: `/shopify-product-fashion-chatbot/`,
        method: "POST",
        body: queryArg.shopifyChatbotProductInput,
      }),
    }),
    signupCreate: build.mutation<SignupCreateApiResponse, SignupCreateApiArg>({
      query: (queryArg) => ({
        url: `/signup/`,
        method: "POST",
        body: queryArg.signUp,
      }),
    }),
    postSingeMarketplaceProductDetails: build.mutation<
      PostSingeMarketplaceProductDetailsApiResponse,
      PostSingeMarketplaceProductDetailsApiArg
    >({
      query: (queryArg) => ({
        url: `/singe-marketplace-product-details/`,
        method: "POST",
        body: queryArg.singleProductMatch,
      }),
    }),
    postStoreLogin: build.mutation<
      PostStoreLoginApiResponse,
      PostStoreLoginApiArg
    >({
      query: (queryArg) => ({
        url: `/store-login/`,
        method: "POST",
        body: queryArg.login,
      }),
    }),
    postStoreVirtualTryOn: build.mutation<
      PostStoreVirtualTryOnApiResponse,
      PostStoreVirtualTryOnApiArg
    >({
      query: (queryArg) => ({
        url: `/store-virtual-try-on/`,
        method: "POST",
        body: queryArg.virtualTryOn,
      }),
    }),
    postThreadMessages: build.mutation<
      PostThreadMessagesApiResponse,
      PostThreadMessagesApiArg
    >({
      query: (queryArg) => ({
        url: `/thread-messages/`,
        method: "POST",
        body: queryArg.messagesRequest,
      }),
    }),
    postTokenRefresh: build.mutation<
      PostTokenRefreshApiResponse,
      PostTokenRefreshApiArg
    >({
      query: (queryArg) => ({
        url: `/token-refresh/`,
        method: "POST",
        body: queryArg.tokenRefresh,
      }),
    }),
    postUpdateStreamedFashionChatbotMarketplaceMobile: build.mutation<
      PostUpdateStreamedFashionChatbotMarketplaceMobileApiResponse,
      PostUpdateStreamedFashionChatbotMarketplaceMobileApiArg
    >({
      query: (queryArg) => ({
        url: `/update-streamed-fashion-chatbot-marketplace-mobile/`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postUploadImage: build.mutation<
      PostUploadImageApiResponse,
      PostUploadImageApiArg
    >({
      query: (queryArg) => ({
        url: `/upload-image/`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getUserFullBodyImage: build.query<
      GetUserFullBodyImageApiResponse,
      GetUserFullBodyImageApiArg
    >({
      query: () => ({ url: `/user-full-body-image/` }),
    }),
    postUserMarketplaceSearch: build.mutation<
      PostUserMarketplaceSearchApiResponse,
      PostUserMarketplaceSearchApiArg
    >({
      query: (queryArg) => ({
        url: `/user-marketplace-search/`,
        method: "POST",
        body: queryArg.body,
        params: {
          gender: queryArg.gender,
          region: queryArg.region,
          garment_type: queryArg.garmentType,
          occasion_type: queryArg.occasionType,
          categories_type: queryArg.categoriesType,
          fit_type: queryArg.fitType,
          size_type: queryArg.sizeType,
          color: queryArg.color,
          aesthetic: queryArg.aesthetic,
          sustainability: queryArg.sustainability,
          min_price: queryArg.minPrice,
          max_price: queryArg.maxPrice,
        },
      }),
    }),
    getUserMarketplaceSuggestions: build.query<
      GetUserMarketplaceSuggestionsApiResponse,
      GetUserMarketplaceSuggestionsApiArg
    >({
      query: () => ({ url: `/user-marketplace-suggestions/` }),
    }),
    getUserPersonalitySurvey: build.query<
      GetUserPersonalitySurveyApiResponse,
      GetUserPersonalitySurveyApiArg
    >({
      query: () => ({ url: `/user-personality-survey/` }),
    }),
    postUserPersonalitySurvey: build.mutation<
      PostUserPersonalitySurveyApiResponse,
      PostUserPersonalitySurveyApiArg
    >({
      query: (queryArg) => ({
        url: `/user-personality-survey/`,
        method: "POST",
        body: queryArg.userPersonality,
      }),
    }),
    postUserSingleMarketplaceProductStream: build.mutation<
      PostUserSingleMarketplaceProductStreamApiResponse,
      PostUserSingleMarketplaceProductStreamApiArg
    >({
      query: (queryArg) => ({
        url: `/user-single-marketplace-product-stream/`,
        method: "POST",
        body: queryArg.singleProductMatch,
      }),
    }),
    postUserSingleMarketplaceProduct: build.mutation<
      PostUserSingleMarketplaceProductApiResponse,
      PostUserSingleMarketplaceProductApiArg
    >({
      query: (queryArg) => ({
        url: `/user-single-marketplace-product/`,
        method: "POST",
        body: queryArg.singleProductMatch,
      }),
    }),
    postUserTopProducts: build.mutation<
      PostUserTopProductsApiResponse,
      PostUserTopProductsApiArg
    >({
      query: (queryArg) => ({
        url: `/user-top-products/`,
        method: "POST",
        body: queryArg.singleProductMatch,
      }),
    }),
    postVerify2Fa: build.mutation<
      PostVerify2FaApiResponse,
      PostVerify2FaApiArg
    >({
      query: (queryArg) => ({
        url: `/verify-2fa/`,
        method: "POST",
        body: queryArg.verify2Fa,
      }),
    }),
    postVerifyAppleAuthMobile: build.mutation<
      PostVerifyAppleAuthMobileApiResponse,
      PostVerifyAppleAuthMobileApiArg
    >({
      query: () => ({ url: `/verify-apple-auth-mobile/`, method: "POST" }),
    }),
    postVerifyGoogleAuthMobile: build.mutation<
      PostVerifyGoogleAuthMobileApiResponse,
      PostVerifyGoogleAuthMobileApiArg
    >({
      query: () => ({ url: `/verify-google-auth-mobile/`, method: "POST" }),
    }),
    postVerifyGoogleAuth: build.mutation<
      PostVerifyGoogleAuthApiResponse,
      PostVerifyGoogleAuthApiArg
    >({
      query: (queryArg) => ({
        url: `/verify-google-auth/`,
        method: "POST",
        body: queryArg.verifyGoogleAuth,
      }),
    }),
    getViewBoards: build.query<GetViewBoardsApiResponse, GetViewBoardsApiArg>({
      query: () => ({ url: `/view-boards/` }),
    }),
    postVirtualTryOn: build.mutation<
      PostVirtualTryOnApiResponse,
      PostVirtualTryOnApiArg
    >({
      query: (queryArg) => ({
        url: `/virtual-try-on/`,
        method: "POST",
        body: queryArg.virtualTryOn,
      }),
    }),
    postWebSearchStatus: build.mutation<
      PostWebSearchStatusApiResponse,
      PostWebSearchStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/web-search-status/`,
        method: "POST",
        body: queryArg.webSearchStatus,
      }),
    }),
    postWebSearch: build.mutation<
      PostWebSearchApiResponse,
      PostWebSearchApiArg
    >({
      query: (queryArg) => ({
        url: `/web-search/`,
        method: "POST",
        body: queryArg.body,
        params: {
          gender: queryArg.gender,
          region: queryArg.region,
          garment_type: queryArg.garmentType,
          color: queryArg.color,
          aesthetic: queryArg.aesthetic,
          sustainability: queryArg.sustainability,
          min_price: queryArg.minPrice,
          max_price: queryArg.maxPrice,
        },
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as rtk };
export type AdminB2BCreateCreateApiResponse = unknown;
export type AdminB2BCreateCreateApiArg = void;
export type AdminB2BCreateDeleteApiResponse = unknown;
export type AdminB2BCreateDeleteApiArg = void;
export type AdminB2BUpdateCreateApiResponse = unknown;
export type AdminB2BUpdateCreateApiArg = {
  id: string;
};
export type AdminB2BUpdateDeleteApiResponse = unknown;
export type AdminB2BUpdateDeleteApiArg = {
  id: string;
};
export type AdminB2BDeleteCreateApiResponse = unknown;
export type AdminB2BDeleteCreateApiArg = {
  id: string;
};
export type AdminB2BDeleteDeleteApiResponse = unknown;
export type AdminB2BDeleteDeleteApiArg = {
  id: string;
};
export type AdminBlogsListApiResponse = unknown;
export type AdminBlogsListApiArg = void;
export type AdminBlogsCreateApiResponse = unknown;
export type AdminBlogsCreateApiArg = void;
export type AdminBlogsReadApiResponse = unknown;
export type AdminBlogsReadApiArg = {
  id: string;
};
export type AdminBlogsUpdateApiResponse = unknown;
export type AdminBlogsUpdateApiArg = {
  id: string;
};
export type AdminBlogsDeleteApiResponse = unknown;
export type AdminBlogsDeleteApiArg = {
  id: string;
};
export type AdminBundlesCreateApiResponse = unknown;
export type AdminBundlesCreateApiArg = void;
export type AdminBundlesUpdateApiResponse = unknown;
export type AdminBundlesUpdateApiArg = void;
export type AdminBundlesDeleteApiResponse = unknown;
export type AdminBundlesDeleteApiArg = void;
export type AdminCategoriesCreateCreateApiResponse = unknown;
export type AdminCategoriesCreateCreateApiArg = void;
export type AdminCategoriesCreateUpdateApiResponse = unknown;
export type AdminCategoriesCreateUpdateApiArg = void;
export type AdminCategoriesCreateDeleteApiResponse = unknown;
export type AdminCategoriesCreateDeleteApiArg = void;
export type AdminCustomerStatusCreateApiResponse = unknown;
export type AdminCustomerStatusCreateApiArg = void;
export type AdminDistributorsCreateCreateApiResponse = unknown;
export type AdminDistributorsCreateCreateApiArg = void;
export type PostAdminExclusiveProductsCreateApiResponse = unknown;
export type PostAdminExclusiveProductsCreateApiArg = void;
export type PutAdminExclusiveProductsCreateApiResponse = unknown;
export type PutAdminExclusiveProductsCreateApiArg = void;
export type DeleteAdminExclusiveProductsCreateApiResponse = unknown;
export type DeleteAdminExclusiveProductsCreateApiArg = void;
export type PostAdminExclusiveProductsByIdApiResponse = unknown;
export type PostAdminExclusiveProductsByIdApiArg = {
  id: string;
};
export type PutAdminExclusiveProductsByIdApiResponse = unknown;
export type PutAdminExclusiveProductsByIdApiArg = {
  id: string;
};
export type DeleteAdminExclusiveProductsByIdApiResponse = unknown;
export type DeleteAdminExclusiveProductsByIdApiArg = {
  id: string;
};
export type AdminLoginCreateApiResponse = unknown;
export type AdminLoginCreateApiArg = void;
export type AdminLogoutCreateApiResponse = unknown;
export type AdminLogoutCreateApiArg = void;
export type PutAdminOrdersByIdUpdateStatusApiResponse = unknown;
export type PutAdminOrdersByIdUpdateStatusApiArg = {
  id: string;
};
export type AdminProductsCreateCreateApiResponse = unknown;
export type AdminProductsCreateCreateApiArg = void;
export type AdminProductsCreateUpdateApiResponse = unknown;
export type AdminProductsCreateUpdateApiArg = void;
export type AdminProductsCreateDeleteApiResponse = unknown;
export type AdminProductsCreateDeleteApiArg = void;
export type AdminProductsCreateApiResponse = unknown;
export type AdminProductsCreateApiArg = {
  id: string;
};
export type AdminProductsUpdateApiResponse = unknown;
export type AdminProductsUpdateApiArg = {
  id: string;
};
export type AdminProductsDeleteApiResponse = unknown;
export type AdminProductsDeleteApiArg = {
  id: string;
};
export type PostAestheticInformationApiResponse =
  /** status 201  */ AestheticLookup;
export type PostAestheticInformationApiArg = {
  aestheticLookup: AestheticLookup;
};
export type PostAestheticProductsApiResponse =
  /** status 201  */ AestheticLookup;
export type PostAestheticProductsApiArg = {
  aestheticLookup: AestheticLookup;
};
export type AestheticsListApiResponse = unknown;
export type AestheticsListApiArg = void;
export type PostAnalyzeFaceApiResponse = /** status 201  */ FaceAnalysis;
export type PostAnalyzeFaceApiArg = {
  faceAnalysis: FaceAnalysis;
};
export type PostApiProductProxyScoreApiResponse =
  /** status 201  */ GenerateScoreInput;
export type PostApiProductProxyScoreApiArg = {
  generateScoreInput: GenerateScoreInput;
};
export type AuthGoogleCallbackListApiResponse = unknown;
export type AuthGoogleCallbackListApiArg = void;
export type PostB2BContactLeadsApiResponse =
  /** status 201  */ B2BContactLeadCreateRead;
export type PostB2BContactLeadsApiArg = {
  b2BContactLeadCreate: B2BContactLeadCreate;
};
export type PostB2BProductScoreApiResponse =
  /** status 201  */ ProductScoreRequest;
export type PostB2BProductScoreApiArg = {
  productScoreRequest: ProductScoreRequest;
};
export type PostB2BProfileReportApiResponse =
  /** status 201  */ CompleteProfile;
export type PostB2BProfileReportApiArg = {
  completeProfile: CompleteProfile;
};
export type PostB2BBuyApiRequestsApiResponse = unknown;
export type PostB2BBuyApiRequestsApiArg = void;
export type PostB2BCompleteBuyRequestApiResponse = unknown;
export type PostB2BCompleteBuyRequestApiArg = void;
export type PostB2BGenerateApiKeyApiResponse = unknown;
export type PostB2BGenerateApiKeyApiArg = void;
export type GetB2BLoginWithTokenApiResponse = unknown;
export type GetB2BLoginWithTokenApiArg = void;
export type B2BLoginCreateApiResponse = unknown;
export type B2BLoginCreateApiArg = void;
export type PostB2BUpdatePasswordApiResponse = unknown;
export type PostB2BUpdatePasswordApiArg = void;
export type GetBodyTypesApiResponse = /** status 200  */ BodyTypeRead[];
export type GetBodyTypesApiArg = void;
export type PostBrandInformationApiResponse = /** status 201  */ BrandLookup;
export type PostBrandInformationApiArg = {
  brandLookup: BrandLookup;
};
export type PostBrandProductsApiResponse = /** status 201  */ BrandLookup;
export type PostBrandProductsApiArg = {
  brandLookup: BrandLookup;
};
export type BrandsListApiResponse = unknown;
export type BrandsListApiArg = void;
export type BundlesListApiResponse = /** status 200  */ BundleDetailRead[];
export type BundlesListApiArg = void;
export type PostCartCheckoutApiResponse = /** status 201  */ Cart;
export type PostCartCheckoutApiArg = {
  cart: Cart;
};
export type PostCheckCategoryApiResponse =
  /** status 201  */ CheckCategoryRequest;
export type PostCheckCategoryApiArg = {
  checkCategoryRequest: CheckCategoryRequest;
};
export type PostCheckSurveyStatusApiResponse = unknown;
export type PostCheckSurveyStatusApiArg = void;
export type PostClaimSurveyApiResponse = /** status 201  */ ClaimSurvey;
export type PostClaimSurveyApiArg = {
  claimSurvey: ClaimSurvey;
};
export type PostCollectionTopMatchesApiResponse =
  /** status 201  */ TopMatchesExclude;
export type PostCollectionTopMatchesApiArg = {
  topMatchesExclude: TopMatchesExclude;
};
export type PostContactUsApiResponse =
  /** status 201  */ ContactUsLeadCreateRead;
export type PostContactUsApiArg = {
  contactUsLeadCreate: ContactUsLeadCreate;
};
export type ConversationsDeleteApiResponse = unknown;
export type ConversationsDeleteApiArg = void;
export type ConversationsListListApiResponse =
  /** status 200  */ ConversationListRead[];
export type ConversationsListListApiArg = void;
export type ConversationsMessagesCreateApiResponse =
  /** status 201  */ GetMessages;
export type ConversationsMessagesCreateApiArg = {
  getMessages: GetMessages;
};
export type ConversationsStoreMessagesCreateApiResponse =
  /** status 201  */ GetMessages;
export type ConversationsStoreMessagesCreateApiArg = {
  getMessages: GetMessages;
};
export type PostCreateBoardApiResponse = /** status 201  */ BoardCreate;
export type PostCreateBoardApiArg = {
  boardCreate: BoardCreate;
};
export type PostCreateConversationApiResponse =
  /** status 201  */ CreateConversation;
export type PostCreateConversationApiArg = {
  createConversation: CreateConversation;
};
export type PostCreateThreadApiResponse = /** status 201  */ Thread;
export type PostCreateThreadApiArg = {
  thread: Thread;
};
export type DeleteDeactivateAccountApiResponse = unknown;
export type DeleteDeactivateAccountApiArg = void;
export type DeleteDeleteBoardApiResponse = unknown;
export type DeleteDeleteBoardApiArg = void;
export type DeleteDeleteConversationApiResponse = unknown;
export type DeleteDeleteConversationApiArg = void;
export type DeleteDeletePinApiResponse = unknown;
export type DeleteDeletePinApiArg = void;
export type DeleteDeleteStoreApiResponse = unknown;
export type DeleteDeleteStoreApiArg = void;
export type PostEditBoardApiResponse = /** status 201  */ BoardRename;
export type PostEditBoardApiArg = {
  boardRename: BoardRename;
};
export type GetExclusiveProductsAllApiResponse = /** status 200  */ {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: ExclusiveProductListRead[];
};
export type GetExclusiveProductsAllApiArg = {
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
};
export type PostExclusiveTopMatchesApiResponse =
  /** status 201  */ ExclusiveRelated;
export type PostExclusiveTopMatchesApiArg = {
  exclusiveRelated: ExclusiveRelated;
};
export type GetFaceShapesApiResponse = /** status 200  */ FaceShapeRead[];
export type GetFaceShapesApiArg = void;
export type GetFashionChatbotApiResponse =
  /** status 200  */ FashionChatbotRequestRead[];
export type GetFashionChatbotApiArg = void;
export type PostFashionChatbotApiResponse =
  /** status 201  */ FashionChatbotRequestRead;
export type PostFashionChatbotApiArg = {
  body: {
    product_id?: number;
    thread_id?: string;
    text?: string;
    image?: Blob;
  };
};
export type GetGetBoardsApiResponse = unknown;
export type GetGetBoardsApiArg = void;
export type PostGetPinsApiResponse = /** status 201  */ PinList;
export type PostGetPinsApiArg = {
  pinList: PinList;
};
export type GetGetUserThreadsApiResponse = unknown;
export type GetGetUserThreadsApiArg = void;
export type GetGoogleLoginApiResponse = unknown;
export type GetGoogleLoginApiArg = void;
export type GetImagesOutfitsApiResponse = unknown;
export type GetImagesOutfitsApiArg = void;
export type InventoryListApiResponse = unknown;
export type InventoryListApiArg = void;
export type LoginCreateApiResponse = /** status 201  */ Login;
export type LoginCreateApiArg = {
  login: Login;
};
export type LogoutCreateApiResponse = unknown;
export type LogoutCreateApiArg = void;
export type GetMarketplaceProductsAllApiResponse = /** status 200  */ {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: ProductRead[];
};
export type GetMarketplaceProductsAllApiArg = {
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
};
export type GetMarketplaceProductsTopApiResponse =
  /** status 200  */ ProductRead[];
export type GetMarketplaceProductsTopApiArg = void;
export type PostMarketplaceSurveySuggestionsApiResponse =
  /** status 201  */ MarketplaceSurveySuggestionRequest;
export type PostMarketplaceSurveySuggestionsApiArg = {
  marketplaceSurveySuggestionRequest: MarketplaceSurveySuggestionRequest;
};
export type PostMenFashionChatbotMobileApiResponse =
  /** status 201  */ MenChatbotRequestRead;
export type PostMenFashionChatbotMobileApiArg = {
  body: {
    conversation_id?: string;
    text: string;
    image?: Blob;
    web_search?: boolean;
  };
};
export type PostMenFashionChatbotApiResponse =
  /** status 201  */ MenChatbotRequestRead;
export type PostMenFashionChatbotApiArg = {
  body: {
    conversation_id?: string;
    text: string;
    image?: Blob;
    web_search?: boolean;
  };
};
export type PostMenStreamedFashionChatbotMobileApiResponse =
  /** status 201  */ MenChatbotRequestRead;
export type PostMenStreamedFashionChatbotMobileApiArg = {
  body: {
    conversation_id?: string;
    text: string;
    image?: Blob;
    web_search?: boolean;
  };
};
export type PostMenStreamedFashionChatbotApiResponse =
  /** status 201  */ MenChatbotRequestRead;
export type PostMenStreamedFashionChatbotApiArg = {
  body: {
    conversation_id?: string;
    text: string;
    image?: Blob;
    web_search?: boolean;
  };
};
export type PostMoreProductsSearchApiResponse =
  /** status 201  */ MoreProductsSearch;
export type PostMoreProductsSearchApiArg = {
  moreProductsSearch: MoreProductsSearch;
};
export type PostMultiGarmentTryOnApiResponse =
  /** status 201  */ MultiGarmentTryOn;
export type PostMultiGarmentTryOnApiArg = {
  multiGarmentTryOn: MultiGarmentTryOn;
};
export type GetMyBodyTypeApiResponse =
  /** status 200  */ BodyTypeWithGroupedCategoriesRead[];
export type GetMyBodyTypeApiArg = void;
export type GetMyColorAnalysisApiResponse =
  /** status 200  */ SeasonalColorDetailRead[];
export type GetMyColorAnalysisApiArg = void;
export type GetMyFaceShapeApiResponse =
  /** status 200  */ FaceShapeWithGroupedRecommendationsRead[];
export type GetMyFaceShapeApiArg = void;
export type PostNewFashionChatbotMobileApiResponse =
  /** status 201  */ NewFashionChatbotRequestRead;
export type PostNewFashionChatbotMobileApiArg = {
  body: {
    conversation_id?: string;
    text: string;
    image?: Blob;
    image_url?: string;
    web_search?: boolean;
    product_id?: number;
    marketplace_product_id?: number;
  };
};
export type PostNewFashionChatbotApiResponse =
  /** status 201  */ NewFashionChatbotRequestRead;
export type PostNewFashionChatbotApiArg = {
  body: {
    conversation_id?: string;
    text: string;
    image?: Blob;
    image_url?: string;
    web_search?: boolean;
    product_id?: number;
    marketplace_product_id?: number;
  };
};
export type PostNewMarketplaceChatbotStreamedApiResponse =
  /** status 201  */ NewMarketplaceChatbotRequestRead;
export type PostNewMarketplaceChatbotStreamedApiArg = {
  body: {
    conversation_id?: string;
    text: string;
    image?: Blob;
    image_url?: string;
    web_search?: boolean;
    product_id?: number;
    marketplace_product_id?: number;
    response?: string;
    is_transfer?: boolean;
  };
};
export type PostNewStreamedFashionChatbotMarketplaceMobileApiResponse =
  /** status 201  */ NewFashionChatbotRequestRead;
export type PostNewStreamedFashionChatbotMarketplaceMobileApiArg = {
  body: {
    conversation_id?: string;
    text: string;
    image?: Blob;
    image_url?: string;
    web_search?: boolean;
    product_id?: number;
    marketplace_product_id?: number;
  };
};
export type PostNewStreamedFashionChatbotMarketplaceApiResponse =
  /** status 201  */ NewFashionChatbotRequestRead;
export type PostNewStreamedFashionChatbotMarketplaceApiArg = {
  body: {
    conversation_id?: string;
    text: string;
    image?: Blob;
    image_url?: string;
    web_search?: boolean;
    product_id?: number;
    marketplace_product_id?: number;
  };
};
export type PostNewStreamedFashionChatbotMobileApiResponse =
  /** status 201  */ NewFashionChatbotRequestRead;
export type PostNewStreamedFashionChatbotMobileApiArg = {
  body: {
    conversation_id?: string;
    text: string;
    image?: Blob;
    image_url?: string;
    web_search?: boolean;
    product_id?: number;
    marketplace_product_id?: number;
  };
};
export type PostNewStreamedFashionChatbotThreadApiResponse =
  /** status 201  */ FashionChatbotRequestSerializerThreadRead;
export type PostNewStreamedFashionChatbotThreadApiArg = {
  body: {
    conversation_id?: string;
    text: string;
    product?: string;
    image_url?: string;
    image?: Blob;
    user_image_url?: string;
    web_search?: boolean;
    store_name: string;
    source?: string;
  };
};
export type PostNewStreamedFashionChatbotApiResponse =
  /** status 201  */ NewFashionChatbotRequestRead;
export type PostNewStreamedFashionChatbotApiArg = {
  body: {
    conversation_id?: string;
    text: string;
    image?: Blob;
    image_url?: string;
    web_search?: boolean;
    product_id?: number;
    marketplace_product_id?: number;
  };
};
export type PostNewWebSearchApiResponse = unknown;
export type PostNewWebSearchApiArg = {
  /** User gender; defaults to profile gender */
  gender?: "male" | "female" | "unisex";
  /** ISO 3166-1 country code (alpha-2 or alpha-3), e.g. 'us' or 'usa' */
  region?: string;
  /** Garment Type */
  garmentType?:
    | "dresses"
    | "tops/shirts"
    | "pants and jeans"
    | "skirts"
    | "jackets"
    | "knitwear"
    | "shorts"
    | "suits"
    | "tops"
    | "pants"
    | "outerwear"
    | "casual"
    | "work"
    | "evening"
    | "summer"
    | "formal";
  /** Occasion Type */
  occasionType?: "casual" | "work" | "formal" | "evening";
  /** Categories Type */
  categoriesType?: "dresses" | "tops" | "bottoms" | "outerwear";
  /** Fit Type */
  fitType?: "slim" | "regular" | "relaxed" | "oversized";
  /** Size Type */
  sizeType?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
  /** Color */
  color?:
    | "black"
    | "white"
    | "beige"
    | "grey"
    | "brown"
    | "blue"
    | "red"
    | "green"
    | "yellow"
    | "pink"
    | "purple"
    | "orange"
    | "metallics"
    | "navy"
    | "gray";
  /** Aesthetic */
  aesthetic?: "minimal" | "streetwear" | "formal" | "boho" | "athleisure";
  /** Sustainability */
  sustainability?:
    | "eco-friendly"
    | "organic"
    | "recycled materials"
    | "vegan"
    | "fair trade / ethical";
  /** Minimum price filter */
  minPrice?: number;
  /** Maximum price filter */
  maxPrice?: number;
  body: {
    text: string;
    image?: Blob;
    urls?: string;
  };
};
export type OrdersListApiResponse = /** status 200  */ OrderListRead[];
export type OrdersListApiArg = void;
export type OrdersStatusReadApiResponse = unknown;
export type OrdersStatusReadApiArg = {
  orderId: string;
};
export type OrdersSuccessReadApiResponse = /** status 200  */ OrderRead;
export type OrdersSuccessReadApiArg = {
  sessionId: string;
};
export type PostPasswordResetConfirmByUidb64AndTokenApiResponse =
  /** status 201  */ PasswordResetConfirm;
export type PostPasswordResetConfirmByUidb64AndTokenApiArg = {
  uidb64: string;
  token: string;
  passwordResetConfirm: PasswordResetConfirm;
};
export type PostPasswordResetApiResponse =
  /** status 201  */ PasswordResetRequest;
export type PostPasswordResetApiArg = {
  passwordResetRequest: PasswordResetRequest;
};
export type PaymentsConfigListApiResponse = unknown;
export type PaymentsConfigListApiArg = void;
export type GetPersonalitySurveyApiResponse =
  /** status 200  */ PersonalityRead[];
export type GetPersonalitySurveyApiArg = void;
export type PostPersonalitySurveyApiResponse =
  /** status 201  */ PersonalityRead;
export type PostPersonalitySurveyApiArg = {
  personality: Personality;
};
export type GetProductSuggestionsApiResponse = unknown;
export type GetProductSuggestionsApiArg = void;
export type GetProductsAllProductsApiResponse = /** status 200  */ {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: ProductRead[];
};
export type GetProductsAllProductsApiArg = {
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
};
export type GetProductsTopMatchesApiResponse = /** status 200  */ ProductRead[];
export type GetProductsTopMatchesApiArg = void;
export type ProductsReadApiResponse = /** status 200  */ ProductDetailRead;
export type ProductsReadApiArg = {
  slug: string;
};
export type ProfileReadApiResponse = /** status 200  */ ProfileRead;
export type ProfileReadApiArg = void;
export type ProfileImagesListApiResponse = unknown;
export type ProfileImagesListApiArg = void;
export type ProfileMeasurementsUpdateApiResponse =
  /** status 200  */ ProfileMeasurement;
export type ProfileMeasurementsUpdateApiArg = {
  profileMeasurement: ProfileMeasurement;
};
export type ProfileMeasurementsStoreUpdateApiResponse =
  /** status 200  */ ProfileMeasurement;
export type ProfileMeasurementsStoreUpdateApiArg = {
  profileMeasurement: ProfileMeasurement;
};
export type ProfileMeasurementsUpdateUpdateApiResponse =
  /** status 200  */ ProfileMeasurementUpdate;
export type ProfileMeasurementsUpdateUpdateApiArg = {
  profileMeasurementUpdate: ProfileMeasurementUpdate;
};
export type ProfileUpdateUpdateApiResponse = /** status 200  */ ProfileUpdate;
export type ProfileUpdateUpdateApiArg = {
  profileUpdate: ProfileUpdate;
};
export type PostPublicCollectionTopMatchesApiResponse =
  /** status 201  */ TopMatchesExclude;
export type PostPublicCollectionTopMatchesApiArg = {
  topMatchesExclude: TopMatchesExclude;
};
export type PostPublicMarketplaceSearchApiResponse = unknown;
export type PostPublicMarketplaceSearchApiArg = {
  /** User gender; defaults to profile gender */
  gender?: "male" | "female" | "unisex";
  /** ISO 3166-1 country code (alpha-2 or alpha-3), e.g. 'us' or 'usa' */
  region?: string;
  /** Garment Type */
  garmentType?:
    | "dresses"
    | "tops/shirts"
    | "pants and jeans"
    | "skirts"
    | "jackets"
    | "knitwear"
    | "shorts"
    | "suits"
    | "tops"
    | "pants"
    | "outerwear"
    | "casual"
    | "work"
    | "evening"
    | "summer"
    | "formal";
  /** Occasion Type */
  occasionType?: "casual" | "work" | "formal" | "evening";
  /** Categories Type */
  categoriesType?: "dresses" | "tops" | "bottoms" | "outerwear";
  /** Fit Type */
  fitType?: "slim" | "regular" | "relaxed" | "oversized";
  /** Size Type */
  sizeType?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
  /** Color */
  color?:
    | "black"
    | "white"
    | "beige"
    | "grey"
    | "brown"
    | "blue"
    | "red"
    | "green"
    | "yellow"
    | "pink"
    | "purple"
    | "orange"
    | "metallics"
    | "navy"
    | "gray";
  /** Aesthetic */
  aesthetic?: "minimal" | "streetwear" | "formal" | "boho" | "athleisure";
  /** Sustainability */
  sustainability?:
    | "eco-friendly"
    | "organic"
    | "recycled materials"
    | "vegan"
    | "fair trade / ethical";
  /** Minimum price filter */
  minPrice?: number;
  /** Maximum price filter */
  maxPrice?: number;
  body: {
    text: string;
    image?: Blob;
    urls?: string;
  };
};
export type GetPublicMarketplaceSuggestionsApiResponse = unknown;
export type GetPublicMarketplaceSuggestionsApiArg = void;
export type PostPublicNewStreamedFashionChatbotThreadApiResponse =
  /** status 201  */ PublicFashionChatbotRequestSerializerThreadRead;
export type PostPublicNewStreamedFashionChatbotThreadApiArg = {
  body: {
    conversation_id?: string;
    text: string;
    product?: string;
    image_url?: string;
    image?: Blob;
    web_search?: boolean;
    store_name: string;
    source?: string;
  };
};
export type PostPublicSingleMarketplaceProductStreamApiResponse =
  /** status 201  */ PublicSingleProductMatch;
export type PostPublicSingleMarketplaceProductStreamApiArg = {
  publicSingleProductMatch: PublicSingleProductMatch;
};
export type PostPublicTopProductsApiResponse =
  /** status 201  */ SingleProductMatch;
export type PostPublicTopProductsApiArg = {
  singleProductMatch: SingleProductMatch;
};
export type PostPublicAnalyzeFaceApiResponse =
  /** status 201  */ PublicFaceAnalysis;
export type PostPublicAnalyzeFaceApiArg = {
  publicFaceAnalysis: PublicFaceAnalysis;
};
export type PublicBlogsListApiResponse = /** status 200  */ {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: BlogPostPublicListRead[];
};
export type PublicBlogsListApiArg = {
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
};
export type PublicBlogsReadApiResponse =
  /** status 200  */ BlogPostPublicDetailRead;
export type PublicBlogsReadApiArg = {
  slug: string;
};
export type PostPublicFashionChatbotApiResponse =
  /** status 201  */ FashionChatbotRequestRead;
export type PostPublicFashionChatbotApiArg = {
  body: {
    product_id?: number;
    thread_id?: string;
    text?: string;
    image?: Blob;
  };
};
export type PublicProductsAllListApiResponse = /** status 200  */ {
  count: number;
  next?: string | null;
  previous?: string | null;
  results: ProductRead[];
};
export type PublicProductsAllListApiArg = {
  /** A page number within the paginated result set. */
  page?: number;
  /** Number of results to return per page. */
  pageSize?: number;
};
export type PublicProductsReadApiResponse =
  /** status 200  */ PublicProductDetailRead;
export type PublicProductsReadApiArg = {
  slug: string;
};
export type PublicProfileMeasurementsStoreUpdateApiResponse =
  /** status 200  */ GuestSurveyMeasurement;
export type PublicProfileMeasurementsStoreUpdateApiArg = {
  guestSurveyMeasurement: GuestSurveyMeasurement;
};
export type PostPublicUploadImageApiResponse =
  /** status 201  */ ImageUploadRead;
export type PostPublicUploadImageApiArg = {
  body: {
    image: Blob;
  };
};
export type PostQuickPayCreateIntentApiResponse =
  /** status 201  */ QuickPayCart;
export type PostQuickPayCreateIntentApiArg = {
  quickPayCart: QuickPayCart;
};
export type GetQuickPayStatusByOrderIdApiResponse =
  /** status 200  */ OrderRead;
export type GetQuickPayStatusByOrderIdApiArg = {
  orderId: string;
};
export type PostResendOtpApiResponse = /** status 201  */ ResendOtp;
export type PostResendOtpApiArg = {
  resendOtp: ResendOtp;
};
export type PostSaveBoardApiResponse = /** status 201  */ Board;
export type PostSaveBoardApiArg = {
  board: Board;
};
export type PostSavePinApiResponse = /** status 201  */ PinSave;
export type PostSavePinApiArg = {
  pinSave: PinSave;
};
export type GetSeasonalColorsApiResponse =
  /** status 200  */ SeasonalColorRead[];
export type GetSeasonalColorsApiArg = void;
export type PostShopifyBypass2FaApiResponse =
  /** status 201  */ ShopifySignedEmail;
export type PostShopifyBypass2FaApiArg = {
  shopifySignedEmail: ShopifySignedEmail;
};
export type PostShopifyEmailLoginApiResponse =
  /** status 201  */ ShopifySignedEmail;
export type PostShopifyEmailLoginApiArg = {
  shopifySignedEmail: ShopifySignedEmail;
};
export type PostShopifyProductFashionChatbotApiResponse =
  /** status 201  */ ShopifyChatbotProductInput;
export type PostShopifyProductFashionChatbotApiArg = {
  shopifyChatbotProductInput: ShopifyChatbotProductInput;
};
export type SignupCreateApiResponse = /** status 201  */ SignUp;
export type SignupCreateApiArg = {
  signUp: SignUp;
};
export type PostSingeMarketplaceProductDetailsApiResponse =
  /** status 201  */ SingleProductMatch;
export type PostSingeMarketplaceProductDetailsApiArg = {
  singleProductMatch: SingleProductMatch;
};
export type PostStoreLoginApiResponse = /** status 201  */ Login;
export type PostStoreLoginApiArg = {
  login: Login;
};
export type PostStoreVirtualTryOnApiResponse = /** status 201  */ VirtualTryOn;
export type PostStoreVirtualTryOnApiArg = {
  virtualTryOn: VirtualTryOn;
};
export type PostThreadMessagesApiResponse = /** status 201  */ MessagesRequest;
export type PostThreadMessagesApiArg = {
  messagesRequest: MessagesRequest;
};
export type PostTokenRefreshApiResponse = /** status 201  */ TokenRefreshRead;
export type PostTokenRefreshApiArg = {
  tokenRefresh: TokenRefresh;
};
export type PostUpdateStreamedFashionChatbotMarketplaceMobileApiResponse =
  /** status 201  */ NewFashionChatbotRequestRead;
export type PostUpdateStreamedFashionChatbotMarketplaceMobileApiArg = {
  body: {
    conversation_id?: string;
    text: string;
    image?: Blob;
    image_url?: string;
    web_search?: boolean;
    product_id?: number;
    marketplace_product_id?: number;
  };
};
export type PostUploadImageApiResponse = /** status 201  */ ImageUploadRead;
export type PostUploadImageApiArg = {
  body: {
    image: Blob;
  };
};
export type GetUserFullBodyImageApiResponse = unknown;
export type GetUserFullBodyImageApiArg = void;
export type PostUserMarketplaceSearchApiResponse = unknown;
export type PostUserMarketplaceSearchApiArg = {
  /** User gender; defaults to profile gender */
  gender?: "male" | "female" | "unisex";
  /** ISO 3166-1 country code (alpha-2 or alpha-3), e.g. 'us' or 'usa' */
  region?: string;
  /** Garment Type */
  garmentType?:
    | "dresses"
    | "tops/shirts"
    | "pants and jeans"
    | "skirts"
    | "jackets"
    | "knitwear"
    | "shorts"
    | "suits"
    | "tops"
    | "pants"
    | "outerwear"
    | "casual"
    | "work"
    | "evening"
    | "summer"
    | "formal";
  /** Occasion Type */
  occasionType?: "casual" | "work" | "formal" | "evening";
  /** Categories Type */
  categoriesType?: "dresses" | "tops" | "bottoms" | "outerwear";
  /** Fit Type */
  fitType?: "slim" | "regular" | "relaxed" | "oversized";
  /** Size Type */
  sizeType?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
  /** Color */
  color?:
    | "black"
    | "white"
    | "beige"
    | "grey"
    | "brown"
    | "blue"
    | "red"
    | "green"
    | "yellow"
    | "pink"
    | "purple"
    | "orange"
    | "metallics"
    | "navy"
    | "gray";
  /** Aesthetic */
  aesthetic?: "minimal" | "streetwear" | "formal" | "boho" | "athleisure";
  /** Sustainability */
  sustainability?:
    | "eco-friendly"
    | "organic"
    | "recycled materials"
    | "vegan"
    | "fair trade / ethical";
  /** Minimum price filter */
  minPrice?: number;
  /** Maximum price filter */
  maxPrice?: number;
  body: {
    text: string;
    image?: Blob;
    urls?: string;
  };
};
export type GetUserMarketplaceSuggestionsApiResponse = unknown;
export type GetUserMarketplaceSuggestionsApiArg = void;
export type GetUserPersonalitySurveyApiResponse =
  /** status 200  */ UserPersonalityRead[];
export type GetUserPersonalitySurveyApiArg = void;
export type PostUserPersonalitySurveyApiResponse =
  /** status 201  */ UserPersonalityRead;
export type PostUserPersonalitySurveyApiArg = {
  userPersonality: UserPersonality;
};
export type PostUserSingleMarketplaceProductStreamApiResponse =
  /** status 201  */ SingleProductMatch;
export type PostUserSingleMarketplaceProductStreamApiArg = {
  singleProductMatch: SingleProductMatch;
};
export type PostUserSingleMarketplaceProductApiResponse =
  /** status 201  */ SingleProductMatch;
export type PostUserSingleMarketplaceProductApiArg = {
  singleProductMatch: SingleProductMatch;
};
export type PostUserTopProductsApiResponse =
  /** status 201  */ SingleProductMatch;
export type PostUserTopProductsApiArg = {
  singleProductMatch: SingleProductMatch;
};
export type PostVerify2FaApiResponse = /** status 201  */ Verify2Fa;
export type PostVerify2FaApiArg = {
  verify2Fa: Verify2Fa;
};
export type PostVerifyAppleAuthMobileApiResponse = unknown;
export type PostVerifyAppleAuthMobileApiArg = void;
export type PostVerifyGoogleAuthMobileApiResponse = unknown;
export type PostVerifyGoogleAuthMobileApiArg = void;
export type PostVerifyGoogleAuthApiResponse =
  /** status 201  */ VerifyGoogleAuth;
export type PostVerifyGoogleAuthApiArg = {
  verifyGoogleAuth: VerifyGoogleAuth;
};
export type GetViewBoardsApiResponse = unknown;
export type GetViewBoardsApiArg = void;
export type PostVirtualTryOnApiResponse = /** status 201  */ VirtualTryOn;
export type PostVirtualTryOnApiArg = {
  virtualTryOn: VirtualTryOn;
};
export type PostWebSearchStatusApiResponse = /** status 201  */ WebSearchStatus;
export type PostWebSearchStatusApiArg = {
  webSearchStatus: WebSearchStatus;
};
export type PostWebSearchApiResponse = unknown;
export type PostWebSearchApiArg = {
  /** User gender; defaults to profile gender */
  gender?: "male" | "female" | "unisex";
  /** ISO 3166-1 country code (alpha-2 or alpha-3), e.g. 'us' or 'usa' */
  region?: string;
  /** Garment Type */
  garmentType?:
    | "dresses"
    | "tops/shirts"
    | "pants and jeans"
    | "skirts"
    | "jackets"
    | "knitwear"
    | "shorts"
    | "suits";
  /** Color */
  color?:
    | "black"
    | "white"
    | "beige"
    | "grey"
    | "brown"
    | "blue"
    | "red"
    | "green"
    | "yellow"
    | "pink"
    | "purple"
    | "orange"
    | "metallics";
  /** Aesthetic */
  aesthetic?: "minimal" | "streetwear" | "formal" | "boho" | "athleisure";
  /** Sustainability */
  sustainability?:
    | "eco-friendly"
    | "organic"
    | "recycled materials"
    | "vegan"
    | "fair trade / ethical";
  /** Minimum price filter */
  minPrice?: number;
  /** Maximum price filter */
  maxPrice?: number;
  body: {
    text: string;
    image?: Blob;
    urls?: string;
  };
};
export type AestheticLookup = {
  id?: number;
  slug?: string;
};
export type FaceAnalysis = {
  image_url: string;
  body_shot_url?: string;
  body_type?: string;
  gender?: string;
};
export type GenerateScoreUserData = {
  email: string;
  clothing_size?: string;
  seasonal_color: string;
  face_shape: string;
  body_type: string;
};
export type GenerateScoreProductAttributes = {
  body_type: {
    [key: string]: number;
  };
  face_shape: {
    [key: string]: number;
  };
  seasonal_color: {
    [key: string]: number;
  };
  body_type_impact: number;
  face_shape_impact: number;
  seasonal_color_impact: number;
  id: number;
  name: string;
};
export type GenerateScoreInput = {
  user: GenerateScoreUserData;
  product: GenerateScoreProductAttributes;
};
export type B2BContactLeadCreate = {
  full_name: string;
  company_name: string;
  role?: string;
  phone_number: string;
  email: string;
};
export type B2BContactLeadCreateRead = {
  id?: number;
  full_name: string;
  company_name: string;
  role?: string;
  phone_number: string;
  email: string;
  status?: "new" | "contacted" | "qualified" | "closed";
  created_at?: string;
  updated_at?: string;
};
export type UserData = {
  name: string;
  size: "XS" | "S" | "M" | "L" | "XL";
  seasonal_color_analysis: string;
  face_shape: string;
  body_shape: string;
};
export type ProductScoreRequest = {
  user: UserData;
  product_id: number;
  product_name: string;
  product_description: string;
};
export type CompleteProfile = {
  image_url: string;
  body_type: string;
  measurement_system: "imperial" | "metric";
  height?: string;
  weight?: string;
  waist_size?: string;
  inseam?: string;
  clothing_size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  bra_band_size?: number;
  bra_cup_size?: string;
};
export type BodyType = {};
export type BodyTypeRead = {
  id?: number;
  name?: string;
};
export type BrandLookup = {
  id?: number;
  slug?: string;
};
export type BundleDetail = {
  name: string;
  slug: string;
  description?: string;
  discount_percent?: number;
};
export type ExclusiveProductList = {
  name: string;
  slug: string;
  quantity: number;
  price: string;
  discount?: number;
  distributor: string;
  category: string;
};
export type ExclusiveProductListRead = {
  id?: number;
  name: string;
  slug: string;
  created_date?: string;
  quantity: number;
  price: string;
  discount?: number;
  discounted_price?: string;
  image?: string;
  distributor: string;
  category: string;
  variants?: string;
};
export type BundleDetailRead = {
  id?: number;
  name: string;
  slug: string;
  description?: string;
  discount_percent?: number;
  image_url?: string;
  product_ids?: string;
  products?: ExclusiveProductListRead[];
};
export type CartItem = {
  variant_id: number;
  quantity: number;
};
export type CartBundle = {
  bundle_id?: number;
  slug?: string;
  quantity: number;
  variant_ids: number[];
};
export type Cart = {
  items?: CartItem[];
  bundles?: CartBundle[];
  email?: string;
  first_name?: string;
  last_name?: string;
  phone?: string;
  address: string;
};
export type CheckCategoryRequest = {
  store_name: string;
  handle: string;
};
export type ClaimSurvey = {
  token: string;
};
export type TopMatchesExclude = {
  product_id?: number;
  slug?: string;
};
export type ContactUsLeadCreate = {
  name: string;
  email: string;
  phone_number: string;
  message: string;
};
export type ContactUsLeadCreateRead = {
  id?: number;
  name: string;
  email: string;
  phone_number: string;
  message: string;
  created_at?: string;
  updated_at?: string;
};
export type ConversationList = {
  title: string;
};
export type ConversationListRead = {
  id?: string;
  title: string;
};
export type GetMessages = {
  conversation_id?: string | null;
};
export type BoardCreate = {
  board_name: string;
};
export type CreateConversation = {
  title: string;
};
export type Thread = {
  thread_id: string;
};
export type BoardRename = {
  board_id?: number;
  board_slug?: string;
  name: string;
};
export type ExclusiveRelated = {
  product_id?: number;
  slug?: string;
};
export type FaceShape = {};
export type FaceShapeRead = {
  id?: number;
  name?: string;
};
export type FashionChatbotRequest = {
  product_id?: number;
  thread_id?: string;
  text?: string;
};
export type FashionChatbotRequestRead = {
  product_id?: number;
  thread_id?: string;
  text?: string;
  image?: string;
};
export type PinList = {
  board_id?: number | null;
  board_slug?: string | null;
};
export type Login = {
  email: string;
  password: string;
};
export type Product = {
  name: string;
  slug: string;
  is_marketplace?: boolean;
  marketplace_title?: string | null;
  quantity: number;
  price: string;
  discount?: number;
  distributor: string;
  category: string;
};
export type ProductRead = {
  id?: number;
  name: string;
  slug: string;
  is_marketplace?: boolean;
  marketplace_title?: string | null;
  created_date?: string;
  quantity: number;
  price: string;
  discount?: number;
  discounted_price?: string;
  image?: string;
  product_score?: string;
  distributor: string;
  category: string;
};
export type SurveySuggestionUserData = {
  face_shape: string;
  body_type: string;
  seasonal_color: string;
  gender: string;
  waist?: string | null;
  clothing_size?: string | null;
};
export type MarketplaceSurveySuggestionRequest = {
  user_data: SurveySuggestionUserData;
  force_refresh?: boolean;
};
export type MenChatbotRequest = {
  conversation_id?: string | null;
  text: string;
  web_search?: boolean;
};
export type MenChatbotRequestRead = {
  conversation_id?: string | null;
  text: string;
  image?: string;
  web_search?: boolean;
};
export type MoreProductsSearch = {
  query: string;
  ids?: object[];
  slugs?: string[];
};
export type MultiGarmentTryOn = {
  person_url: string;
  selected_size?: string | null;
  product_slug: string;
  product_type?: "marketplace" | "product";
  pins?: string[];
};
export type BodyTypeWithGroupedCategories = {
  headline: string;
  summary: string;
  image_url?: string | null;
  traits: string[];
  styling_goals: string[];
};
export type BodyTypeWithGroupedCategoriesRead = {
  name?: string;
  headline: string;
  summary: string;
  image_url?: string | null;
  traits: string[];
  styling_goals: string[];
  categories?: string;
};
export type SeasonalColorDetail = {
  name:
    | "light_summer"
    | "cool_summer"
    | "soft_summer"
    | "true_summer"
    | "deep_winter"
    | "cool_winter"
    | "bright_winter"
    | "deep_autumn"
    | "warm_autumn"
    | "soft_autumn"
    | "true_autumn"
    | "dark_autumn"
    | "light_spring"
    | "warm_spring"
    | "bright_spring";
  summary: string;
  color_pallete_image?: string | null;
  face_image?: string | null;
};
export type SeasonalColorDetailRead = {
  name:
    | "light_summer"
    | "cool_summer"
    | "soft_summer"
    | "true_summer"
    | "deep_winter"
    | "cool_winter"
    | "bright_winter"
    | "deep_autumn"
    | "warm_autumn"
    | "soft_autumn"
    | "true_autumn"
    | "dark_autumn"
    | "light_spring"
    | "warm_spring"
    | "bright_spring";
  summary: string;
  color_pallete_image?: string | null;
  face_image?: string | null;
  best_neutrals?: string;
  best_colors?: string;
  colors_to_avoid?: string;
  recommendations?: string;
};
export type FaceShapeWithGroupedRecommendations = {
  headline: string;
  summary: string;
  image_url?: string | null;
};
export type FaceShapeWithGroupedRecommendationsRead = {
  name?: string;
  headline: string;
  summary: string;
  image_url?: string | null;
  recommended_necklines?: string;
  avoid_necklines?: string;
};
export type NewFashionChatbotRequest = {
  conversation_id?: string | null;
  text: string;
  image_url?: string | null;
  web_search?: boolean;
  product_id?: number;
  marketplace_product_id?: number | null;
};
export type NewFashionChatbotRequestRead = {
  conversation_id?: string | null;
  text: string;
  image?: string;
  image_url?: string | null;
  web_search?: boolean;
  product_id?: number;
  marketplace_product_id?: number | null;
};
export type NewMarketplaceChatbotRequest = {
  conversation_id?: string | null;
  text: string;
  image_url?: string | null;
  web_search?: boolean;
  product_id?: number;
  marketplace_product_id?: number | null;
  response?: string;
  is_transfer?: boolean;
};
export type NewMarketplaceChatbotRequestRead = {
  conversation_id?: string | null;
  text: string;
  image?: string;
  image_url?: string | null;
  web_search?: boolean;
  product_id?: number;
  marketplace_product_id?: number | null;
  response?: string;
  is_transfer?: boolean;
};
export type FashionChatbotRequestSerializerThread = {
  conversation_id?: string | null;
  text: string;
  product?: object | null;
  image_url?: string | null;
  user_image_url?: string | null;
  web_search?: boolean;
  store_name: string;
  source?: string;
};
export type FashionChatbotRequestSerializerThreadRead = {
  conversation_id?: string | null;
  text: string;
  product?: object | null;
  image_url?: string | null;
  image?: string;
  user_image_url?: string | null;
  web_search?: boolean;
  store_name: string;
  source?: string;
};
export type OrderItemBrief = {
  product_name: string;
  color: string;
  size: string;
  price: string;
  discount_percent: number;
  quantity?: number;
  bundle_name?: string | null;
};
export type OrderItemBriefRead = {
  product_name: string;
  product_image?: string;
  color: string;
  size: string;
  price: string;
  original_price?: string;
  unit_price?: string;
  discount_percent: number;
  quantity?: number;
  bundle_group_id?: string;
  bundle_name?: string | null;
};
export type OrderList = {
  status?:
    | "Under Processing"
    | "Under Preparation"
    | "Order Shipped"
    | "Order Delivered"
    | "Order Cancelled";
  paid_at?: string | null;
  items: OrderItemBrief[];
};
export type OrderListRead = {
  id?: string;
  status?:
    | "Under Processing"
    | "Under Preparation"
    | "Order Shipped"
    | "Order Delivered"
    | "Order Cancelled";
  paid_at?: string | null;
  total_amount?: string;
  discounted_amount?: string;
  items: OrderItemBriefRead[];
};
export type ProductVariantRead = {
  color: string;
  size: string;
  price: string;
  sku: string;
  quantity: number;
  image_url?: string | null;
  product?: number | null;
  exclusive_product?: number | null;
};
export type ProductVariantReadRead = {
  id?: number;
  created_at?: string;
  updated_at?: string;
  color: string;
  size: string;
  price: string;
  sku: string;
  quantity: number;
  image_url?: string | null;
  product?: number | null;
  exclusive_product?: number | null;
};
export type OrderItem = {
  variant: ProductVariantRead;
  quantity?: number;
  discount_percent: number;
  bundle_name?: string | null;
};
export type OrderItemRead = {
  id?: number;
  variant: ProductVariantReadRead;
  quantity?: number;
  original_price?: string;
  unit_price?: string;
  discount_percent: number;
  line_total?: string;
  savings?: string;
  bundle_group_id?: string;
  bundle_name?: string | null;
};
export type Order = {
  status?:
    | "Under Processing"
    | "Under Preparation"
    | "Order Shipped"
    | "Order Delivered"
    | "Order Cancelled";
  paid_at?: string | null;
  shipping_address?: string | null;
  items: OrderItem[];
};
export type OrderRead = {
  id?: string;
  status?:
    | "Under Processing"
    | "Under Preparation"
    | "Order Shipped"
    | "Order Delivered"
    | "Order Cancelled";
  paid_at?: string | null;
  shipping_address?: string | null;
  total_amount?: string;
  discounted_amount?: string;
  items: OrderItemRead[];
};
export type PasswordResetConfirm = {
  uidb64: string;
  token: string;
  password: string;
};
export type PasswordResetRequest = {
  email: string;
};
export type Personality = {
  sustainability_preference?: string[] | null;
  sustainability_influence?: string | null;
  everyday_clothing_expenditure_preference?: string | null;
  dresses_coats_expenditure_preference?: string | null;
  bags_accessories_expenditure_preference?: string | null;
  looks_vs_comfort_preference?: string | null;
  shopping_preference?: string | null;
  age?: string | null;
  location?: string | null;
  occupation?: string | null;
  favoured_brands?: string | null;
  disliked_brands?: string | null;
  more_information?: string | null;
  ratings?: object | null;
  uploaded_images?: string[];
};
export type PersonalityRead = {
  id?: number;
  sustainability_preference?: string[] | null;
  sustainability_influence?: string | null;
  everyday_clothing_expenditure_preference?: string | null;
  dresses_coats_expenditure_preference?: string | null;
  bags_accessories_expenditure_preference?: string | null;
  looks_vs_comfort_preference?: string | null;
  shopping_preference?: string | null;
  age?: string | null;
  location?: string | null;
  occupation?: string | null;
  favoured_brands?: string | null;
  disliked_brands?: string | null;
  more_information?: string | null;
  ratings?: object | null;
  ratings_summary?: string | null;
  uploaded_images?: string[];
};
export type ProductDetail = {
  name: string;
  description: string;
  user_description?: string;
  price: string;
  discount?: number;
  quantity: number;
  face_shape_impact: string;
  body_type_impact: string;
  seasonal_color_impact: string;
  face_shape: object;
  body_type: object;
  seasonal_color: object;
  is_marketplace: boolean;
  marketplace_title: string;
  marketplace_url: string;
};
export type ProductDetailRead = {
  id?: number;
  name: string;
  description: string;
  user_description?: string;
  price: string;
  discount?: number;
  discounted_price?: string;
  quantity: number;
  main_images?: string;
  overall_match?: string;
  face_match?: string;
  body_type_match?: string;
  face_shape_impact: string;
  body_type_impact: string;
  seasonal_color_impact: string;
  face_shape: object;
  body_type: object;
  seasonal_color: object;
  is_marketplace: boolean;
  marketplace_title: string;
  marketplace_url: string;
  variants?: string;
};
export type Profile = {};
export type ProfileRead = {
  first_name?: string;
  last_name?: string;
  email?: string;
  phone_number?: string | null;
  address_line1?: string | null;
  address_line2?: string | null;
  city?: string | null;
  state?: string | null;
  country?: string | null;
  postal_code?: string | null;
  face_shape?: number | null;
  hair_color?: string | null;
  hair_color_code?: string | null;
  eye_color?: string | null;
  eye_color_code?: string | null;
  complexion?: string | null;
  complexion_code?: string | null;
  skin_tone?: string | null;
  skin_tone_code?: string | null;
  body_type?: number | null;
  seasonal_color?: number | null;
  measurement_system?: ("imperial" | "metric") | null;
  height?: string | null;
  weight?: string | null;
  waist_size?: string | null;
  inseam?: string | null;
  clothing_size?: ("XXS" | "XS" | "S" | "M" | "L" | "XL" | "XXL") | null;
  bra_band_size?: number | null;
  bra_cup_size?: string | null;
  gender?: number | null;
  style_aesthetics?: string[] | null;
  advanced_measurements?: object | null;
  survey_headshot_url?: string | null;
  survey_full_body_url?: string | null;
  survey_body_angle_urls?: string[] | null;
};
export type ProfileMeasurement = {
  measurement_system?: ("imperial" | "metric") | null;
  height?: string | null;
  weight?: string | null;
  waist_size?: string | null;
  inseam?: string | null;
  clothing_size?: ("XXS" | "XS" | "S" | "M" | "L" | "XL" | "XXL") | null;
  bra_band_size?: number | null;
  bra_cup_size?: string | null;
  style_aesthetics?: string[] | null;
  advanced_measurements?: object | null;
  survey_headshot_url?: string | null;
  survey_full_body_url?: string | null;
  survey_body_angle_urls?: string[] | null;
};
export type ProfileMeasurementUpdate = {
  measurement_system?: ("imperial" | "metric") | null;
  height?: string | null;
  weight?: string | null;
  waist_size?: string | null;
  inseam?: string | null;
  clothing_size?: ("XXS" | "XS" | "S" | "M" | "L" | "XL" | "XXL") | null;
  bra_band_size?: number | null;
  bra_cup_size?: string | null;
  style_aesthetics?: string[] | null;
  advanced_measurements?: object | null;
  survey_headshot_url?: string | null;
  survey_full_body_url?: string | null;
  survey_body_angle_urls?: string[] | null;
  face_shape?: number | null;
  body_type?: number | null;
  hair_color?: string | null;
  eye_color?: string | null;
  complexion?: string | null;
  skin_tone?: string | null;
  seasonal_color?: number | null;
};
export type ProfileUpdate = {
  first_name?: string;
  last_name?: string;
  email?: string;
  phone_number?: string | null;
  address_line1?: string | null;
  address_line2?: string | null;
  city?: string | null;
  state?: string | null;
  country?: string | null;
  postal_code?: string | null;
};
export type PublicFashionChatbotRequestSerializerThread = {
  conversation_id?: string | null;
  text: string;
  product?: {
    [key: string]: string | null;
  };
  image_url?: string | null;
  web_search?: boolean;
  store_name: string;
  source?: string;
};
export type PublicFashionChatbotRequestSerializerThreadRead = {
  conversation_id?: string | null;
  text: string;
  product?: {
    [key: string]: string | null;
  };
  image_url?: string | null;
  image?: string;
  web_search?: boolean;
  store_name: string;
  source?: string;
};
export type PublicSingleProductMatch = {
  product_id?: number;
  slug?: string;
  match_percentage?: number | null;
  force_refresh?: boolean;
  product_type?: "marketplace" | "product" | "exclusive";
  page?: number;
  page_size?: number;
  token: string;
};
export type SingleProductMatch = {
  product_id?: number;
  slug?: string;
  match_percentage?: number | null;
  force_refresh?: boolean;
  product_type?: "marketplace" | "product" | "exclusive";
  page?: number;
  page_size?: number;
};
export type PublicFaceAnalysis = {
  image_url: string;
  body_shot_url?: string;
  body_type?: string;
  gender: string;
};
export type BlogPostPublicList = {
  slug?: string;
  title: string;
  hero_image_url?: string | null;
  published_at?: string | null;
};
export type BlogPostPublicListRead = {
  id?: number;
  slug?: string;
  title: string;
  preview?: string;
  hero_image_url?: string | null;
  author_name?: string;
  published_at?: string | null;
};
export type BlogPostPublicDetail = {
  slug?: string;
  title: string;
  hero_image_url?: string | null;
  content_md: string;
  published_at?: string | null;
};
export type BlogPostPublicDetailRead = {
  id?: number;
  slug?: string;
  title: string;
  hero_image_url?: string | null;
  content_md: string;
  author_name?: string;
  published_at?: string | null;
};
export type PublicProductDetail = {
  name: string;
  description: string;
  user_description?: string;
  price: string;
  discount?: number;
  quantity: number;
  face_shape_impact: string;
  body_type_impact: string;
  seasonal_color_impact: string;
  face_shape: object;
  body_type: object;
  seasonal_color: object;
  is_marketplace: boolean;
  marketplace_title: string;
  marketplace_url: string;
};
export type PublicProductDetailRead = {
  id?: number;
  name: string;
  description: string;
  user_description?: string;
  price: string;
  discount?: number;
  discounted_price?: string;
  quantity: number;
  main_images?: string;
  overall_match?: string;
  face_match?: string;
  body_type_match?: string;
  face_shape_impact: string;
  body_type_impact: string;
  seasonal_color_impact: string;
  face_shape: object;
  body_type: object;
  seasonal_color: object;
  is_marketplace: boolean;
  marketplace_title: string;
  marketplace_url: string;
  variants?: string;
};
export type GuestSurveyMeasurement = {
  measurement_system?: ("imperial" | "metric") | null;
  height?: string | null;
  weight?: string | null;
  waist_size?: string | null;
  inseam?: string | null;
  clothing_size?: string | null;
  bra_band_size?: number | null;
  bra_cup_size?: string | null;
  style_aesthetics?: string[] | null;
  advanced_measurements?: object | null;
  survey_headshot_url?: string | null;
  survey_full_body_url?: string | null;
  survey_body_angle_urls?: string[] | null;
};
export type ImageUpload = {};
export type ImageUploadRead = {
  image?: string;
};
export type QuickPayCart = {
  items?: CartItem[];
  bundles?: CartBundle[];
  email?: string;
  first_name?: string;
  last_name?: string;
  phone?: string;
  address?: string;
  confirmation_token_id?: string;
};
export type ResendOtp = {
  email: string;
};
export type Board = {
  product_id?: number;
  slug?: string;
  match_percentage?: number | null;
  product_type?: "marketplace" | "product";
};
export type PinSave = {
  board_id?: number;
  board_slug?: string;
  product_id?: number;
  slug?: string;
  match_percentage?: number | null;
  product_type?: "marketplace" | "product";
};
export type SeasonalColor = {};
export type SeasonalColorRead = {
  id?: number;
  name?: string;
};
export type ShopifySignedEmail = {
  email: string;
  signature: string;
};
export type ShopifyChatbotProductInput = {
  conversation_id?: string | null;
  text: string;
  product: {
    [key: string]: string | null;
  };
  image_url?: string;
};
export type SignUp = {
  email: string;
  first_name?: string;
  last_name?: string;
  date_of_birth?: string | null;
  password: string;
  is_shopify?: boolean;
};
export type VirtualTryOn = {
  /** URL of the person's image */
  model_image: string;
  /** URL of the garment image */
  garment_image: string;
};
export type MessagesRequest = {
  thread_id: string;
};
export type TokenRefresh = {
  refresh: string;
};
export type TokenRefreshRead = {
  refresh: string;
  access?: string;
};
export type UserPersonality = {
  sustainability_preference?: string[] | null;
  sustainability_influence?: string | null;
  everyday_clothing_expenditure_preference?: string[] | null;
  dresses_coats_expenditure_preference?: string[] | null;
  bags_accessories_expenditure_preference?: string[] | null;
  looks_vs_comfort_preference?: string[] | null;
  shopping_preference?: string[] | null;
  age?: string | null;
  location?: string | null;
  occupation?: string | null;
  favoured_brands?: string | null;
  disliked_brands?: string | null;
  more_information?: string | null;
  ratings?: object | null;
  uploaded_images?: string[];
};
export type UserPersonalityRead = {
  id?: number;
  sustainability_preference?: string[] | null;
  sustainability_influence?: string | null;
  everyday_clothing_expenditure_preference?: string[] | null;
  dresses_coats_expenditure_preference?: string[] | null;
  bags_accessories_expenditure_preference?: string[] | null;
  looks_vs_comfort_preference?: string[] | null;
  shopping_preference?: string[] | null;
  age?: string | null;
  location?: string | null;
  occupation?: string | null;
  favoured_brands?: string | null;
  disliked_brands?: string | null;
  more_information?: string | null;
  ratings?: object | null;
  ratings_summary?: string | null;
  uploaded_images?: string[];
};
export type Verify2Fa = {
  email: string;
  pin: string;
};
export type VerifyGoogleAuth = {
  google_auth_key: string;
};
export type WebSearchStatus = {
  task_id: string;
};
export const {
  useAdminB2BCreateCreateMutation,
  useAdminB2BCreateDeleteMutation,
  useAdminB2BUpdateCreateMutation,
  useAdminB2BUpdateDeleteMutation,
  useAdminB2BDeleteCreateMutation,
  useAdminB2BDeleteDeleteMutation,
  useAdminBlogsListQuery,
  useAdminBlogsCreateMutation,
  useAdminBlogsReadQuery,
  useAdminBlogsUpdateMutation,
  useAdminBlogsDeleteMutation,
  useAdminBundlesCreateMutation,
  useAdminBundlesUpdateMutation,
  useAdminBundlesDeleteMutation,
  useAdminCategoriesCreateCreateMutation,
  useAdminCategoriesCreateUpdateMutation,
  useAdminCategoriesCreateDeleteMutation,
  useAdminCustomerStatusCreateMutation,
  useAdminDistributorsCreateCreateMutation,
  usePostAdminExclusiveProductsCreateMutation,
  usePutAdminExclusiveProductsCreateMutation,
  useDeleteAdminExclusiveProductsCreateMutation,
  usePostAdminExclusiveProductsByIdMutation,
  usePutAdminExclusiveProductsByIdMutation,
  useDeleteAdminExclusiveProductsByIdMutation,
  useAdminLoginCreateMutation,
  useAdminLogoutCreateMutation,
  usePutAdminOrdersByIdUpdateStatusMutation,
  useAdminProductsCreateCreateMutation,
  useAdminProductsCreateUpdateMutation,
  useAdminProductsCreateDeleteMutation,
  useAdminProductsCreateMutation,
  useAdminProductsUpdateMutation,
  useAdminProductsDeleteMutation,
  usePostAestheticInformationMutation,
  usePostAestheticProductsMutation,
  useAestheticsListQuery,
  usePostAnalyzeFaceMutation,
  usePostApiProductProxyScoreMutation,
  useAuthGoogleCallbackListQuery,
  usePostB2BContactLeadsMutation,
  usePostB2BProductScoreMutation,
  usePostB2BProfileReportMutation,
  usePostB2BBuyApiRequestsMutation,
  usePostB2BCompleteBuyRequestMutation,
  usePostB2BGenerateApiKeyMutation,
  useGetB2BLoginWithTokenQuery,
  useB2BLoginCreateMutation,
  usePostB2BUpdatePasswordMutation,
  useGetBodyTypesQuery,
  usePostBrandInformationMutation,
  usePostBrandProductsMutation,
  useBrandsListQuery,
  useBundlesListQuery,
  usePostCartCheckoutMutation,
  usePostCheckCategoryMutation,
  usePostCheckSurveyStatusMutation,
  usePostClaimSurveyMutation,
  usePostCollectionTopMatchesMutation,
  usePostContactUsMutation,
  useConversationsDeleteMutation,
  useConversationsListListQuery,
  useConversationsMessagesCreateMutation,
  useConversationsStoreMessagesCreateMutation,
  usePostCreateBoardMutation,
  usePostCreateConversationMutation,
  usePostCreateThreadMutation,
  useDeleteDeactivateAccountMutation,
  useDeleteDeleteBoardMutation,
  useDeleteDeleteConversationMutation,
  useDeleteDeletePinMutation,
  useDeleteDeleteStoreMutation,
  usePostEditBoardMutation,
  useGetExclusiveProductsAllQuery,
  usePostExclusiveTopMatchesMutation,
  useGetFaceShapesQuery,
  useGetFashionChatbotQuery,
  usePostFashionChatbotMutation,
  useGetGetBoardsQuery,
  usePostGetPinsMutation,
  useGetGetUserThreadsQuery,
  useGetGoogleLoginQuery,
  useGetImagesOutfitsQuery,
  useInventoryListQuery,
  useLoginCreateMutation,
  useLogoutCreateMutation,
  useGetMarketplaceProductsAllQuery,
  useGetMarketplaceProductsTopQuery,
  usePostMarketplaceSurveySuggestionsMutation,
  usePostMenFashionChatbotMobileMutation,
  usePostMenFashionChatbotMutation,
  usePostMenStreamedFashionChatbotMobileMutation,
  usePostMenStreamedFashionChatbotMutation,
  usePostMoreProductsSearchMutation,
  usePostMultiGarmentTryOnMutation,
  useGetMyBodyTypeQuery,
  useGetMyColorAnalysisQuery,
  useGetMyFaceShapeQuery,
  usePostNewFashionChatbotMobileMutation,
  usePostNewFashionChatbotMutation,
  usePostNewMarketplaceChatbotStreamedMutation,
  usePostNewStreamedFashionChatbotMarketplaceMobileMutation,
  usePostNewStreamedFashionChatbotMarketplaceMutation,
  usePostNewStreamedFashionChatbotMobileMutation,
  usePostNewStreamedFashionChatbotThreadMutation,
  usePostNewStreamedFashionChatbotMutation,
  usePostNewWebSearchMutation,
  useOrdersListQuery,
  useOrdersStatusReadQuery,
  useOrdersSuccessReadQuery,
  usePostPasswordResetConfirmByUidb64AndTokenMutation,
  usePostPasswordResetMutation,
  usePaymentsConfigListQuery,
  useGetPersonalitySurveyQuery,
  usePostPersonalitySurveyMutation,
  useGetProductSuggestionsQuery,
  useGetProductsAllProductsQuery,
  useGetProductsTopMatchesQuery,
  useProductsReadQuery,
  useProfileReadQuery,
  useProfileImagesListQuery,
  useProfileMeasurementsUpdateMutation,
  useProfileMeasurementsStoreUpdateMutation,
  useProfileMeasurementsUpdateUpdateMutation,
  useProfileUpdateUpdateMutation,
  usePostPublicCollectionTopMatchesMutation,
  usePostPublicMarketplaceSearchMutation,
  useGetPublicMarketplaceSuggestionsQuery,
  usePostPublicNewStreamedFashionChatbotThreadMutation,
  usePostPublicSingleMarketplaceProductStreamMutation,
  usePostPublicTopProductsMutation,
  usePostPublicAnalyzeFaceMutation,
  usePublicBlogsListQuery,
  usePublicBlogsReadQuery,
  usePostPublicFashionChatbotMutation,
  usePublicProductsAllListQuery,
  usePublicProductsReadQuery,
  usePublicProfileMeasurementsStoreUpdateMutation,
  usePostPublicUploadImageMutation,
  usePostQuickPayCreateIntentMutation,
  useGetQuickPayStatusByOrderIdQuery,
  usePostResendOtpMutation,
  usePostSaveBoardMutation,
  usePostSavePinMutation,
  useGetSeasonalColorsQuery,
  usePostShopifyBypass2FaMutation,
  usePostShopifyEmailLoginMutation,
  usePostShopifyProductFashionChatbotMutation,
  useSignupCreateMutation,
  usePostSingeMarketplaceProductDetailsMutation,
  usePostStoreLoginMutation,
  usePostStoreVirtualTryOnMutation,
  usePostThreadMessagesMutation,
  usePostTokenRefreshMutation,
  usePostUpdateStreamedFashionChatbotMarketplaceMobileMutation,
  usePostUploadImageMutation,
  useGetUserFullBodyImageQuery,
  usePostUserMarketplaceSearchMutation,
  useGetUserMarketplaceSuggestionsQuery,
  useGetUserPersonalitySurveyQuery,
  usePostUserPersonalitySurveyMutation,
  usePostUserSingleMarketplaceProductStreamMutation,
  usePostUserSingleMarketplaceProductMutation,
  usePostUserTopProductsMutation,
  usePostVerify2FaMutation,
  usePostVerifyAppleAuthMobileMutation,
  usePostVerifyGoogleAuthMobileMutation,
  usePostVerifyGoogleAuthMutation,
  useGetViewBoardsQuery,
  usePostVirtualTryOnMutation,
  usePostWebSearchStatusMutation,
  usePostWebSearchMutation,
} = injectedRtkApi;
